unit unit_EinzelTicket;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, DB,
  WEBLib.Grids, XData.Web.Client, strutils, WEBLib.DBCtrls, WEBLib.WebCtrls,
  WEBLib.ComCtrls;

type
  TEinzelTicket = class(TForm)
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    btnzurueck: TButton;
    xdsTicket: TXDataWebDataSet;
    TC: TTableControl;
    btnSpeichern: TButton;
    xdsTicketKundennummer: TXDataWebEntityField;
    xdsTicketKundennummerZahlungsbedingung: TXDataWebEntityField;
    xdsTicketKundennummerKundennummer: TStringField;
    xdsTicketKundennummerGruppeKunden: TBooleanField;
    xdsTicketKundennummerGruppeLieferanten: TBooleanField;
    xdsTicketKundennummerGruppeSonstige: TBooleanField;
    xdsTicketKundennummerGruppeNichtkunden: TBooleanField;
    xdsTicketKundennummerKontaktgruppe: TStringField;
    xdsTicketKundennummerNachname: TStringField;
    xdsTicketKundennummerVorname: TStringField;
    xdsTicketKundennummerAdresszeile2: TStringField;
    xdsTicketKundennummerAdresszeile3: TStringField;
    xdsTicketKundennummerStrasse: TStringField;
    xdsTicketKundennummerPostleitzahl: TStringField;
    xdsTicketKundennummerOrt: TStringField;
    xdsTicketKundennummerLaenderkuerzel: TStringField;
    xdsTicketKundennummerLand: TStringField;
    xdsTicketKundennummerLaenderkennzeichen: TBooleanField;
    xdsTicketKundennummerAdressanrede: TStringField;
    xdsTicketKundennummerBriefanrede1: TStringField;
    xdsTicketKundennummerBriefanrede2: TStringField;
    xdsTicketKundennummerAdresseBild: TStringField;
    xdsTicketKundennummerLieferanschrift: TStringField;
    xdsTicketKundennummerGeburtsdatum: TDateTimeField;
    xdsTicketKundennummerTelefonNummer: TStringField;
    xdsTicketKundennummerTelefaxNummer: TStringField;
    xdsTicketKundennummerMobilTelefon: TStringField;
    xdsTicketKundennummerEMail: TStringField;
    xdsTicketKundennummerInternet: TStringField;
    xdsTicketKundennummerUmsatzsteuerID: TStringField;
    xdsTicketKundennummerUmsatzsteuerausweis: TBooleanField;
    xdsTicketKundennummerBemerkungen: TStringField;
    xdsTicketKundennummerBranche: TStringField;
    xdsTicketKundennummerSelektiert1: TBooleanField;
    xdsTicketKundennummerSelektiert2: TBooleanField;
    xdsTicketKundennummerSelektiert3: TBooleanField;
    xdsTicketKundennummerTransportbedingung: TStringField;
    xdsTicketKundennummerKilometer: TIntegerField;
    xdsTicketKundennummerRabattsatz: TFloatField;
    xdsTicketKundennummerStundensatz: TFloatField;
    xdsTicketKundennummerKontonummer: TStringField;
    xdsTicketKundennummerBank: TStringField;
    xdsTicketKundennummerBankleitzahl: TFloatField;
    xdsTicketKundennummerKontoinhaber: TStringField;
    xdsTicketKundennummerBetreuer: TStringField;
    xdsTicketKundennummerQuelle: TStringField;
    xdsTicketKundennummerSuchmerkmal: TStringField;
    xdsTicketKundennummerWarenkreditlimit: TFloatField;
    xdsTicketKundennummerWarenkreditgesperrt: TBooleanField;
    xdsTicketKundennummerKundennummerFremd: TStringField;
    xdsTicketKundennummerKeinNewsletter: TBooleanField;
    xdsTicketKundennummerDebitorennummer: TStringField;
    xdsTicketKundennummerKreditorennummer: TStringField;
    xdsTicketKundennummerRabattstufe: TStringField;
    xdsTicketKundennummerTelefonAlternativ: TStringField;
    xdsTicketKundennummerKostentraeger: TStringField;
    xdsTicketKundennummerIBAN: TStringField;
    xdsTicketKundennummerBIC: TStringField;
    xdsTicketKundennummerEmailkonto: TStringField;
    xdsTicketKundennummerBenutzername: TStringField;
    xdsTicketKundennummerPasswort: TStringField;
    xdsTicketKundennummerExportOutlook: TBooleanField;
    xdsTicketKundennummerNichtInListeAnzeigen: TBooleanField;
    xdsTicketKundennummerKreditkarteArt: TStringField;
    xdsTicketKundennummerKreditkarteInhaber: TStringField;
    xdsTicketKundennummerKreditkarteNummer: TStringField;
    xdsTicketKundennummerKreditkarteGueltigMonat: TStringField;
    xdsTicketKundennummerKreditkarteGueltigJahr: TIntegerField;
    xdsTicketKundennummerKreditkartePruefziffer: TStringField;
    xdsTicketKundennummerDatumNeu: TDateTimeField;
    xdsTicketKundennummerDatumgeaendert: TDateTimeField;
    xdsTicketKundennummerTitel: TStringField;
    xdsTicketKundennummerStundensatzMontage: TFloatField;
    xdsTicketKundennummerStdMontageU25: TFloatField;
    xdsTicketKundennummerStdMontageU50: TFloatField;
    xdsTicketKundennummerStdMontageU70: TFloatField;
    xdsTicketKundennummerStdMontageU100: TFloatField;
    xdsTicketKundennummerStdMontageU150: TFloatField;
    xdsTicketKundennummerStundensatzWerkstatt: TFloatField;
    xdsTicketKundennummerStdWerkstattU25: TFloatField;
    xdsTicketKundennummerStdWerkstattU50: TFloatField;
    xdsTicketKundennummerStdWerkstattU70: TFloatField;
    xdsTicketKundennummerStdWerkstattU100: TFloatField;
    xdsTicketKundennummerStdWerkstattU150: TFloatField;
    xdsTicketKundennummerArchivReferenz: TStringField;
    xdsTicketKundennummerErloesKontoUST1: TStringField;
    xdsTicketKundennummerErloesKontoUST2: TStringField;
    xdsTicketKundennummerErloesKontoUST3: TStringField;
    xdsTicketKundennummerGebKal: TBooleanField;
    xdsTicketKundennummerEmailversand: TBooleanField;
    xdsTicketKundennummerMahnspesen: TBooleanField;
    xdsTicketKundennummerRechnungSchluss: TStringField;
    xdsTicketKundennummerBenutzerNeu: TStringField;
    xdsTicketKundennummerBenutzerGeaendert: TStringField;
    xdsTicketKundennummerBelegsprache: TStringField;
    xdsTicketKundennummerkmSatz: TFloatField;
    xdsTicketKundennummerKundenklassetext: TStringField;
    xdsTicketKundennummerKundenklasseFarbe: TIntegerField;
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger: TStringField;
    xdsTicketKundennummerProtokoll: TStringField;
    xdsTicketKundennummerILNTyp1: TStringField;
    xdsTicketKundennummerILNTyp2: TStringField;
    xdsTicketKundennummerKontaktGUID: TStringField;
    xdsTicketKundennummerPLZGUID: TStringField;
    xdsTicketKundennummerPreislistenVariantePakete: TStringField;
    xdsTicketKundennummerSchluesselRechnungslauf: TStringField;
    xdsTicketKundennummerRechnungEmail: TStringField;
    xdsTicketKundennummerZahlungsbedingungEK: TIntegerField;
    xdsTicketKundennummerTransportbedingungEK: TStringField;
    xdsTicketKundennummerRabattsatzEK: TFloatField;
    xdsTicketKundennummerVertreterMatchcode: TStringField;
    xdsTicketKundennummerVertreterProvisionssatz: TFloatField;
    xdsTicketKundennummerUmsatzVKJahr: TFloatField;
    xdsTicketKundennummerUmsatzVKVorjahr: TFloatField;
    xdsTicketKundennummerUmsatzEKJahr: TFloatField;
    xdsTicketKundennummerUmsatzEKVorjahr: TFloatField;
    xdsTicketKundennummerSteuernummer: TStringField;
    xdsTicketKundennummerLoginPW: TStringField;
    xdsTicketKundennummerREperFax: TBooleanField;
    xdsTicketKundennummerErreichbarkeit: TStringField;
    xdsTicketKundennummerErloesKontoUST4: TStringField;
    xdsTicketKundennummerErloesKontoUST5: TStringField;
    xdsTicketKundennummerErloesKontoUST6: TStringField;
    xdsTicketKundennummerBesteuerungKey: TIntegerField;
    xdsTicketKundennummerAuftraegeJahr: TFloatField;
    xdsTicketKundennummerAuftraegeVorjahr: TFloatField;
    xdsTicketKundennummerLieferadresseID: TIntegerField;
    xdsTicketKundennummerUSTIDgeprueft: TDateTimeField;
    xdsTicketKundennummerKontaktverbund: TStringField;
    xdsTicketKundennummerHinweis: TStringField;
    xdsTicketKundennummerLatitude: TFloatField;
    xdsTicketKundennummerLongitude: TFloatField;
    xdsTicketKundennummerkmLuftlinie: TFloatField;
    xdsTicketKundennummerGoogleID: TStringField;
    xdsTicketKundennummerGoogleUpdatedUTC: TDateTimeField;
    xdsTicketKundennummerBundesland: TStringField;
    xdsTicketKundennummerRegion: TStringField;
    xdsTicketKundennummerMandatsreferenz: TStringField;
    xdsTicketKundennummerMandatsreferenzVom: TDateTimeField;
    xdsTicketKundennummerLastschriftArt: TStringField;
    xdsTicketKundennummerMahnsperre: TBooleanField;
    xdsTicketKundennummerSuchbegriff: TStringField;
    xdsTicketKundennummerLieferanschriftDaten: TStringField;
    xdsTicketKundennummerExportKasse: TBooleanField;
    xdsTicketKundennummerLoeschvormerkungDatum: TDateTimeField;
    xdsTicketKundennummerLoeschvormerkungGrund: TStringField;
    xdsTicketKundennummerPseudonymisiert: TStringField;
    xdsTicketKundennummerLoginAktiv: TIntegerField;
    xdsTicketKundennummerSonstigeDaten: TStringField;
    xdsTicketKundennummerB2C: TBooleanField;
    xdsTicketKundennummerTIN: TStringField;
    xdsTicketKundennummerMindestbestellwert: TFloatField;
    xdsTicketKundennummerBruttoberechnung: TIntegerField;
    xdsTicketKundennummerDruckWHG: TStringField;
    xdsTicketKundennummerBerechtigungen: TStringField;
    xdsTicketKundennummerRechnungCC: TStringField;
    xdsTicketProdukt: TXDataWebEntityField;
    xdsTicketProduktProdukt: TStringField;
    xdsTicketKategorie: TXDataWebEntityField;
    xdsTicketKategorieKategorie: TStringField;
    xdsTicketPrioritaet: TXDataWebEntityField;
    xdsTicketPrioritaetPrioritaet: TIntegerField;
    xdsTicketPrioritaetPrioText: TStringField;
    xdsTicketPrioritaetPrioFarbe: TIntegerField;
    xdsTicketStatus: TXDataWebEntityField;
    xdsTicketID: TIntegerField;
    xdsTicketErstelltAm: TDateTimeField;
    xdsTicketBetreff: TStringField;
    xdsTicketBeschreibung: TStringField;
    xdsTicketAbrechnungsbetrag: TFloatField;
    xdsTicketAbrechnungRechnungsnummer: TStringField;
    xdsTicketAberechnetAm: TDateTimeField;
    xdsTicketErledigtAm: TDateTimeField;
    xdsTicketNachname: TStringField;
    xdsTicketVorname: TStringField;
    xdsTicketEmail: TStringField;
    xdsTicketSystemInfo: TStringField;
    xdsTicketLoesung: TStringField;
    xdsTicketProtokoll: TStringField;
    xdsTicketZeitaufwandMinuten: TIntegerField;
    xdsTicketAbzurechnendeMinuten: TIntegerField;
    xdsTicketAbgerechneteMinuten: TIntegerField;
    xdsTicketBenachrichtigungNEU: TDateTimeField;
    xdsTicketBenachrichtigungLoesung: TDateTimeField;
    xdsTicketInterneBemerkung: TStringField;
    xdsTicketLoesungInfoSenden: TIntegerField;
    xdsTicketKontaktperson: TStringField;
    xdsTicketErreichbarkeitTelefon: TStringField;
    xdsTicketErreichbarkeitWann: TStringField;
    xdsTStatus: TXDataWebDataSet;
    xdsTStatusStatus: TStringField;
    webDBCStatus: TDBComboBox;
    sourceTicket: TDataSource;
    sourceTStatus: TDataSource;
    xdsTicketStatusStatus: TStringField;
    xdsTicketKonversation: TXDataWebDataSet;
    sourceTicketKonversation: TDataSource;
    xdsTicketKonversationTicketID: TXDataWebEntityField;
    xdsTicketKonversationID: TIntegerField;
    xdsTicketKonversationDatumUhrzeit: TDateTimeField;
    xdsTicketKonversationAntwortText: TStringField;
    xdsTicketKonversationNachrichtSenden: TIntegerField;
    xdsTicketKonversationNachrichtGesendet: TDateTimeField;
    btnAntwortNeu: TButton;
    edtNotiz: TMemo;
    btnAntwortSpeichern: TButton;
    xdsTicketKonversationVerfasser: TStringField;
    checkBenachrichtigung: TCheckBox;
    lblinfo: TLabel;
    lblKonversation: TLabel;
    xdsTicketKonversationQuellProgramm: TStringField;
    xdsTicketDateien: TXDataWebDataSet;
    xdsTicketDateienID: TIntegerField;
    xdsTicketDateienDatumUhrzeit: TDateTimeField;
    xdsTicketDateienDateiName: TStringField;
    xdsTicketDateienDateiGroesse: TIntegerField;
    xdsTicketKontaktpersonEmail: TStringField;
    xdskontosaldo: TXDataWebDataSet;
    xdskontosaldoKundennummer: TStringField;
    xdskontosaldoZeitaufwand: TIntegerField;
    xdskontosaldoAbzurechnen: TIntegerField;
    xdskontosaldoGutschrift: TIntegerField;
    xdskontosaldoAbzug: TIntegerField;
    xdskontosaldoSaldo: TIntegerField;
    xdskontosaldoBetrag: TFloatField;
    xdskontosaldoMinutenpreis: TFloatField;
    xdskontosaldoSRestguthaben: TIntegerField;
    xdsSingleFile: TXDataWebDataSet;
    Container4: THTMLContainer;
    Container5: THTMLContainer;
    lblDateien: TLabel;
    xdsSingleFileTicketID: TXDataWebEntityField;
    xdsSingleFileID: TIntegerField;
    xdsSingleFileDatumUhrzeit: TDateTimeField;
    xdsSingleFileFuerLoesung: TIntegerField;
    xdsSingleFileDateiMime: TStringField;
    xdsSingleFileDateiName: TStringField;
    xdsSingleFileDateiGroesse: TIntegerField;
    xdsSingleFileDateiInhaltText: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsTicketAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnSpeichernClick(Sender: TObject);
    procedure xdsTStatusAfterOpen(DataSet: TDataSet);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure sourceTicketStateChange(Sender: TObject);
    procedure xdsTicketAfterPost(DataSet: TDataSet);
    procedure xdsTicketAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsTicketBeforePost(DataSet: TDataSet);
    procedure xdsTicketKonversationAfterOpen(DataSet: TDataSet);
    procedure btnAntwortNeuClick(Sender: TObject);
    procedure btnAntwortSpeichernClick(Sender: TObject);
    procedure xdsTicketKonversationAfterPost(DataSet: TDataSet);
    procedure xdsTicketKonversationAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsTicketDateienAfterOpen(DataSet: TDataSet);
    procedure xdskontosaldoAfterOpen(DataSet: TDataSet);
    procedure xdsSingleFileAfterOpen(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    MerkerTicket:string;
    EinzelCard:THTMLDiv;
    DateiButton:TButton;
    procedure DateiButtonclick(Sender:TObject);
    procedure DownloadBase64File(const Base64Data, FileName, MimeType: string);
    procedure OpenBase64InNewTab(const Base64Data, MimeType: string);
  protected procedure LoadDFMValues; override; end;

var
  EinzelTicket: TEinzelTicket;

implementation
  uses unit1, unit2, unit_BarcodeScan;
{$R *.dfm}


procedure TEinzelTicket.OpenBase64InNewTab(const Base64Data, MimeType: string);
begin
  asm
    var byteCharacters = atob(Base64Data);
    var byteNumbers = [];
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers.push(byteCharacters.charCodeAt(i));
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: MimeType });

    var url = URL.createObjectURL(blob);
    window.open(url, '_blank');

    // Optional: URL später freigeben (wenn du willst)
    // setTimeout(() => URL.revokeObjectURL(url), 10000);
  end;
end;


procedure TEinzelTicket.DownloadBase64File(const Base64Data, FileName, MimeType: string);
begin
  asm
    // base64 zu binären Daten konvertieren
    var byteCharacters = atob(Base64Data);
    var byteNumbers = [];
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers.push(byteCharacters.charCodeAt(i));
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], { type: MimeType });

    // Blob-URL erstellen
    var url = URL.createObjectURL(blob);

    // Link erzeugen und Klick simulieren
    var a = document.createElement("a");
    a.href = url;
    a.download = FileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // URL wieder freigeben
    URL.revokeObjectURL(url);
  end;
end;

procedure TEinzelTicket.DateiButtonclick(Sender: TObject);
var
  myfileid:string;
begin
  with sender as TButton do
  begin
    myfileid:=inttostr(tag);
  end;
  if myfileid<>'' then
  begin
    xdsSingleFile.close;
    xdssinglefile.QueryString:='$filter=ID eq '+myfileid;
    xdssinglefile.Load;
  end;
end;

procedure TEinzelTicket.btnAntwortNeuClick(Sender: TObject);
begin
  btnAntwortNeu.visible:=false;
  lblinfo.Visible:=true;
  checkBenachrichtigung.Visible:=true;
  edtNotiz.visible:=true;
  btnantwortspeichern.Visible:=true;
  edtNotiz.SetFocus;
end;

procedure TEinzelTicket.btnAntwortSpeichernClick(Sender: TObject);
begin
  xdsticketkonversation.Append;
  xdsTicketKonversationTicketID.Value:=xdsTicket.CurrentData;
  xdsTicketKonversationDatumUhrzeit.AsDateTime:=date+time;
  xdsTicketKonversationAntwortText.AsString:=edtnotiz.Text;
  xdsTicketKonversationVerfasser.AsString:=leftstr(trim(BenutzerVorname+' '+BenutzerNachname),50);
  xdsTicketKonversationQuellProgramm.AsString:='CadiaWEB';
  if checkBenachrichtigung.checked then
  begin
    xdsTicketKonversationNachrichtSenden.AsInteger:=1;
  end
  else
  begin
    xdsTicketKonversationNachrichtSenden.AsInteger:=0;
  end;
  xdsTicketkonversation.Post;

end;

procedure TEinzelTicket.btnSpeichernClick(Sender: TObject);
begin
  xdsTicket.Post;
end;

procedure TEinzelTicket.btnzurueckClick(Sender: TObject);
begin
  xdsTicket.Close;
  self.Close;
end;

procedure TEinzelTicket.sourceTicketStateChange(Sender: TObject);
begin
  if xdsTicket.State in dseditmodes then btnspeichern.Enabled:=true else btnspeichern.Enabled:=false;
end;

procedure TEinzelTicket.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  action:=cafree;
end;

procedure TEinzelTicket.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>EinzelTicket</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnSpeichern.parentelement:=myelement;
  webDBCStatus.ParentElement:=myelement;
  //btnSpeichern.Visible:=false;
  //container2.ParentElement:=myelement;
  //container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;


  myelement:=container3.ElementHandle;
  lblkonversation.parentelement:=myelement;
  btnAntwortNeu.ParentElement:=myelement;
  lblinfo.ParentElement:=myelement;
  checkBenachrichtigung.ParentElement:=myelement;
  checkbenachrichtigung.Caption:='';
  edtnotiz.ParentElement:=myelement;
  edtnotiz.text:='';
  edtnotiz.visible:=false;
  container4.ParentElement:=myelement;
  btnantwortspeichern.parentelement:=myelement;

  lblinfo.Visible:=false;
  checkBenachrichtigung.Visible:=false;
  xdsTstatus.load;

end;

procedure TEinzelTicket.xdskontosaldoAfterOpen(DataSet: TDataSet);
begin
  tc.Cells[1,4]:='<b>'+xdskontosaldosaldo.asstring+'</b>';
end;

procedure TEinzelTicket.xdsSingleFileAfterOpen(DataSet: TDataSet);
var
  mysecondpart:string;
  myFileExt:string;
begin
  if xdsSingleFileID.asstring<>'' then
  begin
    myFileExt:=LowerCase(ExtractFileExt(xdsSingleFileDateiName.asstring));
    mysecondpart:=SplitString(xdsSingleFileDateiInhaltText.asstring,',')[1];
    if myfileext='.pdf' then  OpenBase64InNewTab(mysecondpart,'application/pdf');
    if myfileext='.zip' then  DownloadBase64File(mysecondpart,xdssinglefiledateiname.asstring,'application/zip');
    if myfileext='.jpg' then OpenBase64InNewTab(mysecondpart,'image/jpeg');
    if myfileext='.jpeg' then OpenBase64InNewTab(mysecondpart,'image/jpeg');
    if myfileext='.png' then OpenBase64InNewTab(mysecondpart,'image/png');
    if myfileext='.txt' then OpenBase64InNewTab(mysecondpart,'text/plain');
  end;

end;

procedure TEinzelTicket.xdsTicketAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  if info.Records[0].Error<>'' then showmessage(info.Records[0].Error);
  xdsticket.Close;
  xdststatus.close;
  xdsTStatus.load;
end;

procedure TEinzelTicket.xdsTicketAfterOpen(DataSet: TDataSet);
var
  myelement:TJSHTMLElement;
  mytemptext:string;
  Einzelkarte:string;
begin
  btnantwortspeichern.visible:=false;

  tc.Visible:=true;
  Einzelkarte:='';
  Einzelkarte:=Einzelkarte+'<h6 class="card-title m-2">'+'<small>Ticket-ID: </small>'+ xdsticketID.asstring+' | '+formatdatetime('DD.MM.YYYY hh:mm',xdsTicketErstelltAm.AsDateTime)+' | '+xdsticketstatusstatus.asstring+' | '+xdsticketkategoriekategorie.asstring+'</h6>';
  Einzelkarte:=Einzelkarte+'<div class="card-header bg-warning text-cadia4 "><h4>'+xdsTicketBetreff.asstring+'</h4></div>';
  Einzelkarte:=Einzelkarte+'<div class="card-body text-cadia4 "><h6>'+ReplaceStr(xdsticketbeschreibung.asstring,#13+#10,'<BR>')+'</h6></div>';

  mytemptext:='';

  mytemptext:=mytemptext+'<small>Kunde: </small>'+xdsTicketKundennummerKundennummer.asstring+ ' | '+xdsTicketNachname.asstring+'<br>';;
  mytemptext:=mytemptext+'<small>Minuten Zeitaufwand | Abgerechnet: </small>'+xdsticketzeitaufwandminuten.asstring+' | '+xdsticketAbzurechnendeMinuten.asstring;

  tc.colcount:=5;
  tc.rowcount:=6;
  tc.cells[0,0]:='<small>Kontaktperson';
  tc.cells[1,0]:=xdsticketKontaktperson.asstring;
  tc.cells[2,0]:='                     ';
  tc.cells[3,0]:='                     ';
  tc.cells[0,1]:='<small>Telefon';
  tc.cells[1,1]:=xdsticketErreichbarkeitTelefon.asstring;
  tc.cells[0,2]:='<small>Erreichbarkeit';
  tc.cells[1,2]:=xdsticketErreichbarkeitWann.asstring;
  tc.cells[0,3]:='<small>CC-Email an';
  tc.cells[1,3]:=xdsticketKontaktpersonEmail.asstring;
  tc.cells[0,4]:='<small>Supportkonto-Saldo';
  tc.cells[1,4]:='';
  tc.cells[0,5]:='<small>Interne Bemerkung';
  tc.cells[1,5]:=xdsticketInterneBemerkung.asstring;
  Einzelkarte:=Einzelkarte+'<div class="card-footer bg-success-subtle text-dark text-primary">'+mytemptext+'</div>';

  EinzelCard:=THTMLDiv.Create(self);
  EinzelCard.ElementID:=xdsticketID.asstring;
  EinzelCard.HeightStyle:=ssauto;
  EinzelCard.widthStyle:=ssPercent;
  Einzelcard.WidthPercent:=100;
  EinzelCard.HTML.Text:=Einzelkarte;
  EinzelCard.ElementClassName:='card border-secondary m-1 ';

  myelement:=container2.ElementHandle;
  einzelcard.ParentElement:=myelement;















  webdbCStatus.text:=xdsticketstatusstatus.asstring;




  myelement:=einzelcard.ElementHandle;
  tc.ParentElement:=myelement;
  container5.ParentElement:=myelement;
  container5.html.text:='';
  myelement:=Container5.ElementHandle;

  lblDateien.ParentElement:=myelement;

  if xdsTicketDateien.recordcount>0 then
  begin
    xdsTicketDateien.First;
    while not xdsTicketDateien.EOF do
    begin
      DateiButton:=TButton.Create(self);
      DateiButton.ElementClassName:='btn btn-outline-dark btn-sm m-1 text-left';
      DateiButton.HeightStyle:=ssauto;
      DateiButton.WidthStyle:=ssauto;
      DateiButton.tag:=xdsTicketDateienID.AsInteger;
      DateiButton.Caption:=xdsTicketDateienDateiName.AsString;
      DateiButton.OnClick:=@DateiButtonClick;
      DateiButton.ParentElement:=myelement;
      xdsTicketDateien.Next;
    end;
  end;

  myelement:=container2.ElementHandle;
  container3.ParentElement:=myelement;

  xdsticketkonversation.first;
  while not xdsticketkonversation.eof do
  begin
    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:=xdsTicketKonversationID.asstring;

    Einzelkarte:='';
    if xdsTicketKonversationQuellProgramm.asstring='Kundenportal' then
    begin
      Einzelkarte:='<div class="card-header bg-warning text-secondary"><small>'+xdsTicketKonversationVerfasser.AsString+' | '+xdsticketkonversationdatumuhrzeit.asstring+'</div>';
      EinzelCard.ElementClassName:='card border-warning m-1';
    end
    else
    begin
      Einzelkarte:='<div class="card-header bg-cadia4 text-white"><small>'+xdsTicketKonversationVerfasser.AsString+' | '+xdsticketkonversationdatumuhrzeit.asstring+'</div>';
      EinzelCard.ElementClassName:='card border-dark m-1';
    end;
    Einzelkarte:=Einzelkarte+'<div class="card-body text-black">'+xdsticketkonversationantworttext.asstring;

    Einzelkarte:=Einzelkarte+'</div>';
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.widthStyle:=ssPercent;
    Einzelcard.WidthPercent:=100;
    EinzelCard.HTML.Text:=Einzelkarte;

    myelement:=container2.ElementHandle;
    EinzelCard.ParentElement:=myelement;
    xdsticketkonversation.next;
  end;

  if xdsticketloesung.AsString<>'' then
  begin

    EinzelCard:=THTMLDiv.Create(self);
    EinzelCard.ElementID:='Loesung';

    Einzelkarte:='';
    Einzelkarte:='<div class="card-header bg-cadia4 text-white"><small>Lösung | Cadia-Team</div>';
    EinzelCard.ElementClassName:='card border-dark m-1';
    Einzelkarte:=Einzelkarte+'<div class="card-body text-black">'+ReplaceStr(xdsticketloesung.asstring,#13+#10,'<BR>');

    Einzelkarte:=Einzelkarte+'</div>';
    EinzelCard.HeightStyle:=ssauto;
    EinzelCard.widthStyle:=ssPercent;
    Einzelcard.WidthPercent:=100;
    EinzelCard.HTML.Text:=Einzelkarte;
    myelement:=container2.ElementHandle;
    EinzelCard.ParentElement:=myelement;
    btnAntwortNeu.visible:=false;
  end;

  xdskontosaldo.close;
  xdskontosaldo.querystring:='$filter=Kundennummer eq '+xdsticketkundennummerkundennummer.asstring;
  xdskontosaldo.load;
end;

procedure TEinzelTicket.xdsTicketAfterPost(DataSet: TDataSet);
begin
  xdsticket.ApplyUpdates;
end;

procedure TEinzelTicket.xdsTicketBeforePost(DataSet: TDataSet);
begin
  xdsTStatus.locate('Status',webDBCStatus.text,[]);
  xdsTicketStatus.value:=xdsTStatus.CurrentData;
end;

procedure TEinzelTicket.xdsTicketDateienAfterOpen(DataSet: TDataSet);
begin
  xdsticket.close;
  xdsticket.QueryString:='$expand=Kundennummer,Status,Kategorie&$filter=ID eq '+merkerticket;
  xdsticket.Load;
end;

procedure TEinzelTicket.xdsTicketKonversationAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
begin
  if info.Records[0].Error<>'' then showmessage(info.Records[0].Error);
  xdsTicketKonversation.close;
  edtNotiz.Text:='';
  xdsticket.edit;
  //webdbCStatus.text:='neue Antwort vom Kunden';
  xdsticket.Post;

end;

procedure TEinzelTicket.xdsTicketKonversationAfterOpen(DataSet: TDataSet);
begin
  xdsTicketDateien.close;
  xdsTicketDateien.QueryString:='$select=Id, DatumUhrzeit, DateiName,DateiGroesse&$filter=TicketID eq '+merkerticket+'&$orderby=DatumUhrzeit DESC';
  xdsTicketDateien.load;
end;

procedure TEinzelTicket.xdsTicketKonversationAfterPost(DataSet: TDataSet);
begin
  btnAntwortNeu.visible:=true;
  lblinfo.Visible:=false;
  checkBenachrichtigung.Visible:=false;
  edtNotiz.visible:=false;
  btnantwortspeichern.Visible:=false;
  xdsTicketKonversation.ApplyUpdates;
end;

procedure TEinzelTicket.xdsTStatusAfterOpen(DataSet: TDataSet);
begin
  xdsTicketKonversation.close;
  xdsTicketKonversation.QueryString:='$filter=TicketID eq '+merkerticket+'&$orderby=DatumUhrzeit DESC';
  xdsTicketkonversation.load;
end;

procedure TEinzelTicket.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblinfo := TLabel.Create(Self);
  lblKonversation := TLabel.Create(Self);
  lblDateien := TLabel.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  btnSpeichern := TButton.Create(Self);
  webDBCStatus := TDBComboBox.Create(Self);
  btnAntwortNeu := TButton.Create(Self);
  edtNotiz := TMemo.Create(Self);
  btnAntwortSpeichern := TButton.Create(Self);
  checkBenachrichtigung := TCheckBox.Create(Self);
  Container4 := THTMLContainer.Create(Self);
  Container5 := THTMLContainer.Create(Self);
  xdsTicket := TXDataWebDataSet.Create(Self);
  xdsTicketKundennummer := TXDataWebEntityField.Create(Self);
  xdsTicketKundennummerZahlungsbedingung := TXDataWebEntityField.Create(Self);
  xdsTicketKundennummerKundennummer := TStringField.Create(Self);
  xdsTicketKundennummerGruppeKunden := TBooleanField.Create(Self);
  xdsTicketKundennummerGruppeLieferanten := TBooleanField.Create(Self);
  xdsTicketKundennummerGruppeSonstige := TBooleanField.Create(Self);
  xdsTicketKundennummerGruppeNichtkunden := TBooleanField.Create(Self);
  xdsTicketKundennummerKontaktgruppe := TStringField.Create(Self);
  xdsTicketKundennummerNachname := TStringField.Create(Self);
  xdsTicketKundennummerVorname := TStringField.Create(Self);
  xdsTicketKundennummerAdresszeile2 := TStringField.Create(Self);
  xdsTicketKundennummerAdresszeile3 := TStringField.Create(Self);
  xdsTicketKundennummerStrasse := TStringField.Create(Self);
  xdsTicketKundennummerPostleitzahl := TStringField.Create(Self);
  xdsTicketKundennummerOrt := TStringField.Create(Self);
  xdsTicketKundennummerLaenderkuerzel := TStringField.Create(Self);
  xdsTicketKundennummerLand := TStringField.Create(Self);
  xdsTicketKundennummerLaenderkennzeichen := TBooleanField.Create(Self);
  xdsTicketKundennummerAdressanrede := TStringField.Create(Self);
  xdsTicketKundennummerBriefanrede1 := TStringField.Create(Self);
  xdsTicketKundennummerBriefanrede2 := TStringField.Create(Self);
  xdsTicketKundennummerAdresseBild := TStringField.Create(Self);
  xdsTicketKundennummerLieferanschrift := TStringField.Create(Self);
  xdsTicketKundennummerGeburtsdatum := TDateTimeField.Create(Self);
  xdsTicketKundennummerTelefonNummer := TStringField.Create(Self);
  xdsTicketKundennummerTelefaxNummer := TStringField.Create(Self);
  xdsTicketKundennummerMobilTelefon := TStringField.Create(Self);
  xdsTicketKundennummerEMail := TStringField.Create(Self);
  xdsTicketKundennummerInternet := TStringField.Create(Self);
  xdsTicketKundennummerUmsatzsteuerID := TStringField.Create(Self);
  xdsTicketKundennummerUmsatzsteuerausweis := TBooleanField.Create(Self);
  xdsTicketKundennummerBemerkungen := TStringField.Create(Self);
  xdsTicketKundennummerBranche := TStringField.Create(Self);
  xdsTicketKundennummerSelektiert1 := TBooleanField.Create(Self);
  xdsTicketKundennummerSelektiert2 := TBooleanField.Create(Self);
  xdsTicketKundennummerSelektiert3 := TBooleanField.Create(Self);
  xdsTicketKundennummerTransportbedingung := TStringField.Create(Self);
  xdsTicketKundennummerKilometer := TIntegerField.Create(Self);
  xdsTicketKundennummerRabattsatz := TFloatField.Create(Self);
  xdsTicketKundennummerStundensatz := TFloatField.Create(Self);
  xdsTicketKundennummerKontonummer := TStringField.Create(Self);
  xdsTicketKundennummerBank := TStringField.Create(Self);
  xdsTicketKundennummerBankleitzahl := TFloatField.Create(Self);
  xdsTicketKundennummerKontoinhaber := TStringField.Create(Self);
  xdsTicketKundennummerBetreuer := TStringField.Create(Self);
  xdsTicketKundennummerQuelle := TStringField.Create(Self);
  xdsTicketKundennummerSuchmerkmal := TStringField.Create(Self);
  xdsTicketKundennummerWarenkreditlimit := TFloatField.Create(Self);
  xdsTicketKundennummerWarenkreditgesperrt := TBooleanField.Create(Self);
  xdsTicketKundennummerKundennummerFremd := TStringField.Create(Self);
  xdsTicketKundennummerKeinNewsletter := TBooleanField.Create(Self);
  xdsTicketKundennummerDebitorennummer := TStringField.Create(Self);
  xdsTicketKundennummerKreditorennummer := TStringField.Create(Self);
  xdsTicketKundennummerRabattstufe := TStringField.Create(Self);
  xdsTicketKundennummerTelefonAlternativ := TStringField.Create(Self);
  xdsTicketKundennummerKostentraeger := TStringField.Create(Self);
  xdsTicketKundennummerIBAN := TStringField.Create(Self);
  xdsTicketKundennummerBIC := TStringField.Create(Self);
  xdsTicketKundennummerEmailkonto := TStringField.Create(Self);
  xdsTicketKundennummerBenutzername := TStringField.Create(Self);
  xdsTicketKundennummerPasswort := TStringField.Create(Self);
  xdsTicketKundennummerExportOutlook := TBooleanField.Create(Self);
  xdsTicketKundennummerNichtInListeAnzeigen := TBooleanField.Create(Self);
  xdsTicketKundennummerKreditkarteArt := TStringField.Create(Self);
  xdsTicketKundennummerKreditkarteInhaber := TStringField.Create(Self);
  xdsTicketKundennummerKreditkarteNummer := TStringField.Create(Self);
  xdsTicketKundennummerKreditkarteGueltigMonat := TStringField.Create(Self);
  xdsTicketKundennummerKreditkarteGueltigJahr := TIntegerField.Create(Self);
  xdsTicketKundennummerKreditkartePruefziffer := TStringField.Create(Self);
  xdsTicketKundennummerDatumNeu := TDateTimeField.Create(Self);
  xdsTicketKundennummerDatumgeaendert := TDateTimeField.Create(Self);
  xdsTicketKundennummerTitel := TStringField.Create(Self);
  xdsTicketKundennummerStundensatzMontage := TFloatField.Create(Self);
  xdsTicketKundennummerStdMontageU25 := TFloatField.Create(Self);
  xdsTicketKundennummerStdMontageU50 := TFloatField.Create(Self);
  xdsTicketKundennummerStdMontageU70 := TFloatField.Create(Self);
  xdsTicketKundennummerStdMontageU100 := TFloatField.Create(Self);
  xdsTicketKundennummerStdMontageU150 := TFloatField.Create(Self);
  xdsTicketKundennummerStundensatzWerkstatt := TFloatField.Create(Self);
  xdsTicketKundennummerStdWerkstattU25 := TFloatField.Create(Self);
  xdsTicketKundennummerStdWerkstattU50 := TFloatField.Create(Self);
  xdsTicketKundennummerStdWerkstattU70 := TFloatField.Create(Self);
  xdsTicketKundennummerStdWerkstattU100 := TFloatField.Create(Self);
  xdsTicketKundennummerStdWerkstattU150 := TFloatField.Create(Self);
  xdsTicketKundennummerArchivReferenz := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST1 := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST2 := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST3 := TStringField.Create(Self);
  xdsTicketKundennummerGebKal := TBooleanField.Create(Self);
  xdsTicketKundennummerEmailversand := TBooleanField.Create(Self);
  xdsTicketKundennummerMahnspesen := TBooleanField.Create(Self);
  xdsTicketKundennummerRechnungSchluss := TStringField.Create(Self);
  xdsTicketKundennummerBenutzerNeu := TStringField.Create(Self);
  xdsTicketKundennummerBenutzerGeaendert := TStringField.Create(Self);
  xdsTicketKundennummerBelegsprache := TStringField.Create(Self);
  xdsTicketKundennummerkmSatz := TFloatField.Create(Self);
  xdsTicketKundennummerKundenklassetext := TStringField.Create(Self);
  xdsTicketKundennummerKundenklasseFarbe := TIntegerField.Create(Self);
  xdsTicketKundennummerAbweichenderRechnungsEmpfaenger := TStringField.Create(Self);
  xdsTicketKundennummerProtokoll := TStringField.Create(Self);
  xdsTicketKundennummerILNTyp1 := TStringField.Create(Self);
  xdsTicketKundennummerILNTyp2 := TStringField.Create(Self);
  xdsTicketKundennummerKontaktGUID := TStringField.Create(Self);
  xdsTicketKundennummerPLZGUID := TStringField.Create(Self);
  xdsTicketKundennummerPreislistenVariantePakete := TStringField.Create(Self);
  xdsTicketKundennummerSchluesselRechnungslauf := TStringField.Create(Self);
  xdsTicketKundennummerRechnungEmail := TStringField.Create(Self);
  xdsTicketKundennummerZahlungsbedingungEK := TIntegerField.Create(Self);
  xdsTicketKundennummerTransportbedingungEK := TStringField.Create(Self);
  xdsTicketKundennummerRabattsatzEK := TFloatField.Create(Self);
  xdsTicketKundennummerVertreterMatchcode := TStringField.Create(Self);
  xdsTicketKundennummerVertreterProvisionssatz := TFloatField.Create(Self);
  xdsTicketKundennummerUmsatzVKJahr := TFloatField.Create(Self);
  xdsTicketKundennummerUmsatzVKVorjahr := TFloatField.Create(Self);
  xdsTicketKundennummerUmsatzEKJahr := TFloatField.Create(Self);
  xdsTicketKundennummerUmsatzEKVorjahr := TFloatField.Create(Self);
  xdsTicketKundennummerSteuernummer := TStringField.Create(Self);
  xdsTicketKundennummerLoginPW := TStringField.Create(Self);
  xdsTicketKundennummerREperFax := TBooleanField.Create(Self);
  xdsTicketKundennummerErreichbarkeit := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST4 := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST5 := TStringField.Create(Self);
  xdsTicketKundennummerErloesKontoUST6 := TStringField.Create(Self);
  xdsTicketKundennummerBesteuerungKey := TIntegerField.Create(Self);
  xdsTicketKundennummerAuftraegeJahr := TFloatField.Create(Self);
  xdsTicketKundennummerAuftraegeVorjahr := TFloatField.Create(Self);
  xdsTicketKundennummerLieferadresseID := TIntegerField.Create(Self);
  xdsTicketKundennummerUSTIDgeprueft := TDateTimeField.Create(Self);
  xdsTicketKundennummerKontaktverbund := TStringField.Create(Self);
  xdsTicketKundennummerHinweis := TStringField.Create(Self);
  xdsTicketKundennummerLatitude := TFloatField.Create(Self);
  xdsTicketKundennummerLongitude := TFloatField.Create(Self);
  xdsTicketKundennummerkmLuftlinie := TFloatField.Create(Self);
  xdsTicketKundennummerGoogleID := TStringField.Create(Self);
  xdsTicketKundennummerGoogleUpdatedUTC := TDateTimeField.Create(Self);
  xdsTicketKundennummerBundesland := TStringField.Create(Self);
  xdsTicketKundennummerRegion := TStringField.Create(Self);
  xdsTicketKundennummerMandatsreferenz := TStringField.Create(Self);
  xdsTicketKundennummerMandatsreferenzVom := TDateTimeField.Create(Self);
  xdsTicketKundennummerLastschriftArt := TStringField.Create(Self);
  xdsTicketKundennummerMahnsperre := TBooleanField.Create(Self);
  xdsTicketKundennummerSuchbegriff := TStringField.Create(Self);
  xdsTicketKundennummerLieferanschriftDaten := TStringField.Create(Self);
  xdsTicketKundennummerExportKasse := TBooleanField.Create(Self);
  xdsTicketKundennummerLoeschvormerkungDatum := TDateTimeField.Create(Self);
  xdsTicketKundennummerLoeschvormerkungGrund := TStringField.Create(Self);
  xdsTicketKundennummerPseudonymisiert := TStringField.Create(Self);
  xdsTicketKundennummerLoginAktiv := TIntegerField.Create(Self);
  xdsTicketKundennummerSonstigeDaten := TStringField.Create(Self);
  xdsTicketKundennummerB2C := TBooleanField.Create(Self);
  xdsTicketKundennummerTIN := TStringField.Create(Self);
  xdsTicketKundennummerMindestbestellwert := TFloatField.Create(Self);
  xdsTicketKundennummerBruttoberechnung := TIntegerField.Create(Self);
  xdsTicketKundennummerDruckWHG := TStringField.Create(Self);
  xdsTicketKundennummerBerechtigungen := TStringField.Create(Self);
  xdsTicketKundennummerRechnungCC := TStringField.Create(Self);
  xdsTicketProdukt := TXDataWebEntityField.Create(Self);
  xdsTicketProduktProdukt := TStringField.Create(Self);
  xdsTicketKategorie := TXDataWebEntityField.Create(Self);
  xdsTicketKategorieKategorie := TStringField.Create(Self);
  xdsTicketPrioritaet := TXDataWebEntityField.Create(Self);
  xdsTicketPrioritaetPrioritaet := TIntegerField.Create(Self);
  xdsTicketPrioritaetPrioText := TStringField.Create(Self);
  xdsTicketPrioritaetPrioFarbe := TIntegerField.Create(Self);
  xdsTicketStatus := TXDataWebEntityField.Create(Self);
  xdsTicketID := TIntegerField.Create(Self);
  xdsTicketErstelltAm := TDateTimeField.Create(Self);
  xdsTicketBetreff := TStringField.Create(Self);
  xdsTicketBeschreibung := TStringField.Create(Self);
  xdsTicketAbrechnungsbetrag := TFloatField.Create(Self);
  xdsTicketAbrechnungRechnungsnummer := TStringField.Create(Self);
  xdsTicketAberechnetAm := TDateTimeField.Create(Self);
  xdsTicketErledigtAm := TDateTimeField.Create(Self);
  xdsTicketNachname := TStringField.Create(Self);
  xdsTicketVorname := TStringField.Create(Self);
  xdsTicketEmail := TStringField.Create(Self);
  xdsTicketSystemInfo := TStringField.Create(Self);
  xdsTicketLoesung := TStringField.Create(Self);
  xdsTicketProtokoll := TStringField.Create(Self);
  xdsTicketZeitaufwandMinuten := TIntegerField.Create(Self);
  xdsTicketAbzurechnendeMinuten := TIntegerField.Create(Self);
  xdsTicketAbgerechneteMinuten := TIntegerField.Create(Self);
  xdsTicketBenachrichtigungNEU := TDateTimeField.Create(Self);
  xdsTicketBenachrichtigungLoesung := TDateTimeField.Create(Self);
  xdsTicketInterneBemerkung := TStringField.Create(Self);
  xdsTicketLoesungInfoSenden := TIntegerField.Create(Self);
  xdsTicketKontaktperson := TStringField.Create(Self);
  xdsTicketErreichbarkeitTelefon := TStringField.Create(Self);
  xdsTicketErreichbarkeitWann := TStringField.Create(Self);
  xdsTicketStatusStatus := TStringField.Create(Self);
  xdsTicketKontaktpersonEmail := TStringField.Create(Self);
  xdsTStatus := TXDataWebDataSet.Create(Self);
  xdsTStatusStatus := TStringField.Create(Self);
  sourceTicket := TDataSource.Create(Self);
  sourceTStatus := TDataSource.Create(Self);
  xdsTicketKonversation := TXDataWebDataSet.Create(Self);
  xdsTicketKonversationTicketID := TXDataWebEntityField.Create(Self);
  xdsTicketKonversationID := TIntegerField.Create(Self);
  xdsTicketKonversationDatumUhrzeit := TDateTimeField.Create(Self);
  xdsTicketKonversationAntwortText := TStringField.Create(Self);
  xdsTicketKonversationNachrichtSenden := TIntegerField.Create(Self);
  xdsTicketKonversationNachrichtGesendet := TDateTimeField.Create(Self);
  xdsTicketKonversationVerfasser := TStringField.Create(Self);
  xdsTicketKonversationQuellProgramm := TStringField.Create(Self);
  sourceTicketKonversation := TDataSource.Create(Self);
  xdsTicketDateien := TXDataWebDataSet.Create(Self);
  xdsTicketDateienID := TIntegerField.Create(Self);
  xdsTicketDateienDatumUhrzeit := TDateTimeField.Create(Self);
  xdsTicketDateienDateiName := TStringField.Create(Self);
  xdsTicketDateienDateiGroesse := TIntegerField.Create(Self);
  xdskontosaldo := TXDataWebDataSet.Create(Self);
  xdskontosaldoKundennummer := TStringField.Create(Self);
  xdskontosaldoZeitaufwand := TIntegerField.Create(Self);
  xdskontosaldoAbzurechnen := TIntegerField.Create(Self);
  xdskontosaldoGutschrift := TIntegerField.Create(Self);
  xdskontosaldoAbzug := TIntegerField.Create(Self);
  xdskontosaldoSaldo := TIntegerField.Create(Self);
  xdskontosaldoBetrag := TFloatField.Create(Self);
  xdskontosaldoMinutenpreis := TFloatField.Create(Self);
  xdskontosaldoSRestguthaben := TIntegerField.Create(Self);
  xdsSingleFile := TXDataWebDataSet.Create(Self);
  xdsSingleFileTicketID := TXDataWebEntityField.Create(Self);
  xdsSingleFileID := TIntegerField.Create(Self);
  xdsSingleFileDatumUhrzeit := TDateTimeField.Create(Self);
  xdsSingleFileFuerLoesung := TIntegerField.Create(Self);
  xdsSingleFileDateiMime := TStringField.Create(Self);
  xdsSingleFileDateiName := TStringField.Create(Self);
  xdsSingleFileDateiGroesse := TIntegerField.Create(Self);
  xdsSingleFileDateiInhaltText := TStringField.Create(Self);

  lblinfo.BeforeLoadDFMValues;
  lblKonversation.BeforeLoadDFMValues;
  lblDateien.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnSpeichern.BeforeLoadDFMValues;
  webDBCStatus.BeforeLoadDFMValues;
  btnAntwortNeu.BeforeLoadDFMValues;
  edtNotiz.BeforeLoadDFMValues;
  btnAntwortSpeichern.BeforeLoadDFMValues;
  checkBenachrichtigung.BeforeLoadDFMValues;
  Container4.BeforeLoadDFMValues;
  Container5.BeforeLoadDFMValues;
  xdsTicket.BeforeLoadDFMValues;
  xdsTicketKundennummer.BeforeLoadDFMValues;
  xdsTicketKundennummerZahlungsbedingung.BeforeLoadDFMValues;
  xdsTicketKundennummerKundennummer.BeforeLoadDFMValues;
  xdsTicketKundennummerGruppeKunden.BeforeLoadDFMValues;
  xdsTicketKundennummerGruppeLieferanten.BeforeLoadDFMValues;
  xdsTicketKundennummerGruppeSonstige.BeforeLoadDFMValues;
  xdsTicketKundennummerGruppeNichtkunden.BeforeLoadDFMValues;
  xdsTicketKundennummerKontaktgruppe.BeforeLoadDFMValues;
  xdsTicketKundennummerNachname.BeforeLoadDFMValues;
  xdsTicketKundennummerVorname.BeforeLoadDFMValues;
  xdsTicketKundennummerAdresszeile2.BeforeLoadDFMValues;
  xdsTicketKundennummerAdresszeile3.BeforeLoadDFMValues;
  xdsTicketKundennummerStrasse.BeforeLoadDFMValues;
  xdsTicketKundennummerPostleitzahl.BeforeLoadDFMValues;
  xdsTicketKundennummerOrt.BeforeLoadDFMValues;
  xdsTicketKundennummerLaenderkuerzel.BeforeLoadDFMValues;
  xdsTicketKundennummerLand.BeforeLoadDFMValues;
  xdsTicketKundennummerLaenderkennzeichen.BeforeLoadDFMValues;
  xdsTicketKundennummerAdressanrede.BeforeLoadDFMValues;
  xdsTicketKundennummerBriefanrede1.BeforeLoadDFMValues;
  xdsTicketKundennummerBriefanrede2.BeforeLoadDFMValues;
  xdsTicketKundennummerAdresseBild.BeforeLoadDFMValues;
  xdsTicketKundennummerLieferanschrift.BeforeLoadDFMValues;
  xdsTicketKundennummerGeburtsdatum.BeforeLoadDFMValues;
  xdsTicketKundennummerTelefonNummer.BeforeLoadDFMValues;
  xdsTicketKundennummerTelefaxNummer.BeforeLoadDFMValues;
  xdsTicketKundennummerMobilTelefon.BeforeLoadDFMValues;
  xdsTicketKundennummerEMail.BeforeLoadDFMValues;
  xdsTicketKundennummerInternet.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzsteuerID.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzsteuerausweis.BeforeLoadDFMValues;
  xdsTicketKundennummerBemerkungen.BeforeLoadDFMValues;
  xdsTicketKundennummerBranche.BeforeLoadDFMValues;
  xdsTicketKundennummerSelektiert1.BeforeLoadDFMValues;
  xdsTicketKundennummerSelektiert2.BeforeLoadDFMValues;
  xdsTicketKundennummerSelektiert3.BeforeLoadDFMValues;
  xdsTicketKundennummerTransportbedingung.BeforeLoadDFMValues;
  xdsTicketKundennummerKilometer.BeforeLoadDFMValues;
  xdsTicketKundennummerRabattsatz.BeforeLoadDFMValues;
  xdsTicketKundennummerStundensatz.BeforeLoadDFMValues;
  xdsTicketKundennummerKontonummer.BeforeLoadDFMValues;
  xdsTicketKundennummerBank.BeforeLoadDFMValues;
  xdsTicketKundennummerBankleitzahl.BeforeLoadDFMValues;
  xdsTicketKundennummerKontoinhaber.BeforeLoadDFMValues;
  xdsTicketKundennummerBetreuer.BeforeLoadDFMValues;
  xdsTicketKundennummerQuelle.BeforeLoadDFMValues;
  xdsTicketKundennummerSuchmerkmal.BeforeLoadDFMValues;
  xdsTicketKundennummerWarenkreditlimit.BeforeLoadDFMValues;
  xdsTicketKundennummerWarenkreditgesperrt.BeforeLoadDFMValues;
  xdsTicketKundennummerKundennummerFremd.BeforeLoadDFMValues;
  xdsTicketKundennummerKeinNewsletter.BeforeLoadDFMValues;
  xdsTicketKundennummerDebitorennummer.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditorennummer.BeforeLoadDFMValues;
  xdsTicketKundennummerRabattstufe.BeforeLoadDFMValues;
  xdsTicketKundennummerTelefonAlternativ.BeforeLoadDFMValues;
  xdsTicketKundennummerKostentraeger.BeforeLoadDFMValues;
  xdsTicketKundennummerIBAN.BeforeLoadDFMValues;
  xdsTicketKundennummerBIC.BeforeLoadDFMValues;
  xdsTicketKundennummerEmailkonto.BeforeLoadDFMValues;
  xdsTicketKundennummerBenutzername.BeforeLoadDFMValues;
  xdsTicketKundennummerPasswort.BeforeLoadDFMValues;
  xdsTicketKundennummerExportOutlook.BeforeLoadDFMValues;
  xdsTicketKundennummerNichtInListeAnzeigen.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkarteArt.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkarteInhaber.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkarteNummer.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkarteGueltigMonat.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkarteGueltigJahr.BeforeLoadDFMValues;
  xdsTicketKundennummerKreditkartePruefziffer.BeforeLoadDFMValues;
  xdsTicketKundennummerDatumNeu.BeforeLoadDFMValues;
  xdsTicketKundennummerDatumgeaendert.BeforeLoadDFMValues;
  xdsTicketKundennummerTitel.BeforeLoadDFMValues;
  xdsTicketKundennummerStundensatzMontage.BeforeLoadDFMValues;
  xdsTicketKundennummerStdMontageU25.BeforeLoadDFMValues;
  xdsTicketKundennummerStdMontageU50.BeforeLoadDFMValues;
  xdsTicketKundennummerStdMontageU70.BeforeLoadDFMValues;
  xdsTicketKundennummerStdMontageU100.BeforeLoadDFMValues;
  xdsTicketKundennummerStdMontageU150.BeforeLoadDFMValues;
  xdsTicketKundennummerStundensatzWerkstatt.BeforeLoadDFMValues;
  xdsTicketKundennummerStdWerkstattU25.BeforeLoadDFMValues;
  xdsTicketKundennummerStdWerkstattU50.BeforeLoadDFMValues;
  xdsTicketKundennummerStdWerkstattU70.BeforeLoadDFMValues;
  xdsTicketKundennummerStdWerkstattU100.BeforeLoadDFMValues;
  xdsTicketKundennummerStdWerkstattU150.BeforeLoadDFMValues;
  xdsTicketKundennummerArchivReferenz.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST1.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST2.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST3.BeforeLoadDFMValues;
  xdsTicketKundennummerGebKal.BeforeLoadDFMValues;
  xdsTicketKundennummerEmailversand.BeforeLoadDFMValues;
  xdsTicketKundennummerMahnspesen.BeforeLoadDFMValues;
  xdsTicketKundennummerRechnungSchluss.BeforeLoadDFMValues;
  xdsTicketKundennummerBenutzerNeu.BeforeLoadDFMValues;
  xdsTicketKundennummerBenutzerGeaendert.BeforeLoadDFMValues;
  xdsTicketKundennummerBelegsprache.BeforeLoadDFMValues;
  xdsTicketKundennummerkmSatz.BeforeLoadDFMValues;
  xdsTicketKundennummerKundenklassetext.BeforeLoadDFMValues;
  xdsTicketKundennummerKundenklasseFarbe.BeforeLoadDFMValues;
  xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.BeforeLoadDFMValues;
  xdsTicketKundennummerProtokoll.BeforeLoadDFMValues;
  xdsTicketKundennummerILNTyp1.BeforeLoadDFMValues;
  xdsTicketKundennummerILNTyp2.BeforeLoadDFMValues;
  xdsTicketKundennummerKontaktGUID.BeforeLoadDFMValues;
  xdsTicketKundennummerPLZGUID.BeforeLoadDFMValues;
  xdsTicketKundennummerPreislistenVariantePakete.BeforeLoadDFMValues;
  xdsTicketKundennummerSchluesselRechnungslauf.BeforeLoadDFMValues;
  xdsTicketKundennummerRechnungEmail.BeforeLoadDFMValues;
  xdsTicketKundennummerZahlungsbedingungEK.BeforeLoadDFMValues;
  xdsTicketKundennummerTransportbedingungEK.BeforeLoadDFMValues;
  xdsTicketKundennummerRabattsatzEK.BeforeLoadDFMValues;
  xdsTicketKundennummerVertreterMatchcode.BeforeLoadDFMValues;
  xdsTicketKundennummerVertreterProvisionssatz.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzVKJahr.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzVKVorjahr.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzEKJahr.BeforeLoadDFMValues;
  xdsTicketKundennummerUmsatzEKVorjahr.BeforeLoadDFMValues;
  xdsTicketKundennummerSteuernummer.BeforeLoadDFMValues;
  xdsTicketKundennummerLoginPW.BeforeLoadDFMValues;
  xdsTicketKundennummerREperFax.BeforeLoadDFMValues;
  xdsTicketKundennummerErreichbarkeit.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST4.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST5.BeforeLoadDFMValues;
  xdsTicketKundennummerErloesKontoUST6.BeforeLoadDFMValues;
  xdsTicketKundennummerBesteuerungKey.BeforeLoadDFMValues;
  xdsTicketKundennummerAuftraegeJahr.BeforeLoadDFMValues;
  xdsTicketKundennummerAuftraegeVorjahr.BeforeLoadDFMValues;
  xdsTicketKundennummerLieferadresseID.BeforeLoadDFMValues;
  xdsTicketKundennummerUSTIDgeprueft.BeforeLoadDFMValues;
  xdsTicketKundennummerKontaktverbund.BeforeLoadDFMValues;
  xdsTicketKundennummerHinweis.BeforeLoadDFMValues;
  xdsTicketKundennummerLatitude.BeforeLoadDFMValues;
  xdsTicketKundennummerLongitude.BeforeLoadDFMValues;
  xdsTicketKundennummerkmLuftlinie.BeforeLoadDFMValues;
  xdsTicketKundennummerGoogleID.BeforeLoadDFMValues;
  xdsTicketKundennummerGoogleUpdatedUTC.BeforeLoadDFMValues;
  xdsTicketKundennummerBundesland.BeforeLoadDFMValues;
  xdsTicketKundennummerRegion.BeforeLoadDFMValues;
  xdsTicketKundennummerMandatsreferenz.BeforeLoadDFMValues;
  xdsTicketKundennummerMandatsreferenzVom.BeforeLoadDFMValues;
  xdsTicketKundennummerLastschriftArt.BeforeLoadDFMValues;
  xdsTicketKundennummerMahnsperre.BeforeLoadDFMValues;
  xdsTicketKundennummerSuchbegriff.BeforeLoadDFMValues;
  xdsTicketKundennummerLieferanschriftDaten.BeforeLoadDFMValues;
  xdsTicketKundennummerExportKasse.BeforeLoadDFMValues;
  xdsTicketKundennummerLoeschvormerkungDatum.BeforeLoadDFMValues;
  xdsTicketKundennummerLoeschvormerkungGrund.BeforeLoadDFMValues;
  xdsTicketKundennummerPseudonymisiert.BeforeLoadDFMValues;
  xdsTicketKundennummerLoginAktiv.BeforeLoadDFMValues;
  xdsTicketKundennummerSonstigeDaten.BeforeLoadDFMValues;
  xdsTicketKundennummerB2C.BeforeLoadDFMValues;
  xdsTicketKundennummerTIN.BeforeLoadDFMValues;
  xdsTicketKundennummerMindestbestellwert.BeforeLoadDFMValues;
  xdsTicketKundennummerBruttoberechnung.BeforeLoadDFMValues;
  xdsTicketKundennummerDruckWHG.BeforeLoadDFMValues;
  xdsTicketKundennummerBerechtigungen.BeforeLoadDFMValues;
  xdsTicketKundennummerRechnungCC.BeforeLoadDFMValues;
  xdsTicketProdukt.BeforeLoadDFMValues;
  xdsTicketProduktProdukt.BeforeLoadDFMValues;
  xdsTicketKategorie.BeforeLoadDFMValues;
  xdsTicketKategorieKategorie.BeforeLoadDFMValues;
  xdsTicketPrioritaet.BeforeLoadDFMValues;
  xdsTicketPrioritaetPrioritaet.BeforeLoadDFMValues;
  xdsTicketPrioritaetPrioText.BeforeLoadDFMValues;
  xdsTicketPrioritaetPrioFarbe.BeforeLoadDFMValues;
  xdsTicketStatus.BeforeLoadDFMValues;
  xdsTicketID.BeforeLoadDFMValues;
  xdsTicketErstelltAm.BeforeLoadDFMValues;
  xdsTicketBetreff.BeforeLoadDFMValues;
  xdsTicketBeschreibung.BeforeLoadDFMValues;
  xdsTicketAbrechnungsbetrag.BeforeLoadDFMValues;
  xdsTicketAbrechnungRechnungsnummer.BeforeLoadDFMValues;
  xdsTicketAberechnetAm.BeforeLoadDFMValues;
  xdsTicketErledigtAm.BeforeLoadDFMValues;
  xdsTicketNachname.BeforeLoadDFMValues;
  xdsTicketVorname.BeforeLoadDFMValues;
  xdsTicketEmail.BeforeLoadDFMValues;
  xdsTicketSystemInfo.BeforeLoadDFMValues;
  xdsTicketLoesung.BeforeLoadDFMValues;
  xdsTicketProtokoll.BeforeLoadDFMValues;
  xdsTicketZeitaufwandMinuten.BeforeLoadDFMValues;
  xdsTicketAbzurechnendeMinuten.BeforeLoadDFMValues;
  xdsTicketAbgerechneteMinuten.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungNEU.BeforeLoadDFMValues;
  xdsTicketBenachrichtigungLoesung.BeforeLoadDFMValues;
  xdsTicketInterneBemerkung.BeforeLoadDFMValues;
  xdsTicketLoesungInfoSenden.BeforeLoadDFMValues;
  xdsTicketKontaktperson.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitTelefon.BeforeLoadDFMValues;
  xdsTicketErreichbarkeitWann.BeforeLoadDFMValues;
  xdsTicketStatusStatus.BeforeLoadDFMValues;
  xdsTicketKontaktpersonEmail.BeforeLoadDFMValues;
  xdsTStatus.BeforeLoadDFMValues;
  xdsTStatusStatus.BeforeLoadDFMValues;
  sourceTicket.BeforeLoadDFMValues;
  sourceTStatus.BeforeLoadDFMValues;
  xdsTicketKonversation.BeforeLoadDFMValues;
  xdsTicketKonversationTicketID.BeforeLoadDFMValues;
  xdsTicketKonversationID.BeforeLoadDFMValues;
  xdsTicketKonversationDatumUhrzeit.BeforeLoadDFMValues;
  xdsTicketKonversationAntwortText.BeforeLoadDFMValues;
  xdsTicketKonversationNachrichtSenden.BeforeLoadDFMValues;
  xdsTicketKonversationNachrichtGesendet.BeforeLoadDFMValues;
  xdsTicketKonversationVerfasser.BeforeLoadDFMValues;
  xdsTicketKonversationQuellProgramm.BeforeLoadDFMValues;
  sourceTicketKonversation.BeforeLoadDFMValues;
  xdsTicketDateien.BeforeLoadDFMValues;
  xdsTicketDateienID.BeforeLoadDFMValues;
  xdsTicketDateienDatumUhrzeit.BeforeLoadDFMValues;
  xdsTicketDateienDateiName.BeforeLoadDFMValues;
  xdsTicketDateienDateiGroesse.BeforeLoadDFMValues;
  xdskontosaldo.BeforeLoadDFMValues;
  xdskontosaldoKundennummer.BeforeLoadDFMValues;
  xdskontosaldoZeitaufwand.BeforeLoadDFMValues;
  xdskontosaldoAbzurechnen.BeforeLoadDFMValues;
  xdskontosaldoGutschrift.BeforeLoadDFMValues;
  xdskontosaldoAbzug.BeforeLoadDFMValues;
  xdskontosaldoSaldo.BeforeLoadDFMValues;
  xdskontosaldoBetrag.BeforeLoadDFMValues;
  xdskontosaldoMinutenpreis.BeforeLoadDFMValues;
  xdskontosaldoSRestguthaben.BeforeLoadDFMValues;
  xdsSingleFile.BeforeLoadDFMValues;
  xdsSingleFileTicketID.BeforeLoadDFMValues;
  xdsSingleFileID.BeforeLoadDFMValues;
  xdsSingleFileDatumUhrzeit.BeforeLoadDFMValues;
  xdsSingleFileFuerLoesung.BeforeLoadDFMValues;
  xdsSingleFileDateiMime.BeforeLoadDFMValues;
  xdsSingleFileDateiName.BeforeLoadDFMValues;
  xdsSingleFileDateiGroesse.BeforeLoadDFMValues;
  xdsSingleFileDateiInhaltText.BeforeLoadDFMValues;
  try
    Name := 'EinzelTicket';
    Width := 588;
    Height := 643;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblinfo.SetParentComponent(Self);
    lblinfo.Name := 'lblinfo';
    lblinfo.Left := 40;
    lblinfo.Top := 488;
    lblinfo.Width := 177;
    lblinfo.Height := 15;
    lblinfo.Caption := 'Antwort auch per Email zusenden';
    lblinfo.ElementClassName := 'text-small m-2';
    lblinfo.ElementFont := efCSS;
    lblinfo.ElementPosition := epIgnore;
    lblinfo.HeightStyle := ssAuto;
    lblinfo.HeightPercent := 100.000000000000000000;
    lblinfo.WidthStyle := ssAuto;
    lblinfo.WidthPercent := 100.000000000000000000;
    lblKonversation.SetParentComponent(Self);
    lblKonversation.Name := 'lblKonversation';
    lblKonversation.Left := 24;
    lblKonversation.Top := 528;
    lblKonversation.Width := 69;
    lblKonversation.Height := 15;
    lblKonversation.Caption := 'Konversation';
    lblKonversation.ElementClassName := 'h5 m-2';
    lblKonversation.ElementFont := efCSS;
    lblKonversation.ElementPosition := epIgnore;
    lblKonversation.HeightStyle := ssAuto;
    lblKonversation.HeightPercent := 100.000000000000000000;
    lblKonversation.WidthStyle := ssAuto;
    lblKonversation.WidthPercent := 100.000000000000000000;
    lblDateien.SetParentComponent(Self);
    lblDateien.Name := 'lblDateien';
    lblDateien.Left := 24;
    lblDateien.Top := 576;
    lblDateien.Width := 180;
    lblDateien.Height := 15;
    lblDateien.Caption := 'Dateien/Anlagen zu diesem Ticket';
    lblDateien.ElementClassName := 'h6 m-2';
    lblDateien.ElementFont := efCSS;
    lblDateien.ElementPosition := epIgnore;
    lblDateien.HeightStyle := ssAuto;
    lblDateien.HeightPercent := 100.000000000000000000;
    lblDateien.WidthStyle := ssAuto;
    lblDateien.WidthPercent := 100.000000000000000000;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ChildOrder := 2;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 5;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex flex-wrap m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 5;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 156;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := -1;
    TC.Top := 191;
    TC.Width := 247;
    TC.Height := 91;
    TC.ElementClassName := 'table';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.WidthPercent := 99.000000000000000000;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-sm table-warning m-2';
    TC.RowHeader := False;
    TC.WordWrap := True;
    TC.ColCount := 1;
    btnSpeichern.SetParentComponent(Self);
    btnSpeichern.Name := 'btnSpeichern';
    btnSpeichern.Left := 8;
    btnSpeichern.Top := 210;
    btnSpeichern.Width := 96;
    btnSpeichern.Height := 25;
    btnSpeichern.Caption := 'speichern';
    btnSpeichern.ChildOrder := 6;
    btnSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnSpeichern.ElementFont := efCSS;
    btnSpeichern.ElementPosition := epIgnore;
    btnSpeichern.HeightStyle := ssAuto;
    btnSpeichern.HeightPercent := 100.000000000000000000;
    btnSpeichern.WidthStyle := ssAuto;
    btnSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnSpeichern, Self, 'OnClick', 'btnSpeichernClick');
    webDBCStatus.SetParentComponent(Self);
    webDBCStatus.Name := 'webDBCStatus';
    webDBCStatus.Left := 24;
    webDBCStatus.Top := 298;
    webDBCStatus.Width := 185;
    webDBCStatus.Height := 23;
    webDBCStatus.ChildOrder := 9;
    webDBCStatus.ElementClassName := 'form-control w-55 m-1';
    webDBCStatus.ElementFont := efCSS;
    webDBCStatus.ElementPosition := epIgnore;
    webDBCStatus.HeightStyle := ssAuto;
    webDBCStatus.HeightPercent := 100.000000000000000000;
    webDBCStatus.Text := 'webDBCStatus';
    webDBCStatus.WidthStyle := ssPercent;
    webDBCStatus.WidthPercent := 55.000000000000000000;
    webDBCStatus.ItemIndex := -1;
    webDBCStatus.DataField := 'Status';
    webDBCStatus.DataSource := sourceTicket;
    webDBCStatus.ListField := 'Status';
    webDBCStatus.ListSource := sourceTStatus;
    btnAntwortNeu.SetParentComponent(Self);
    btnAntwortNeu.Name := 'btnAntwortNeu';
    btnAntwortNeu.Left := 8;
    btnAntwortNeu.Top := 418;
    btnAntwortNeu.Width := 96;
    btnAntwortNeu.Height := 25;
    btnAntwortNeu.Caption := 'neue Antwort';
    btnAntwortNeu.ChildOrder := 6;
    btnAntwortNeu.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnAntwortNeu.ElementFont := efCSS;
    btnAntwortNeu.ElementPosition := epIgnore;
    btnAntwortNeu.HeightStyle := ssAuto;
    btnAntwortNeu.HeightPercent := 100.000000000000000000;
    btnAntwortNeu.WidthStyle := ssAuto;
    btnAntwortNeu.WidthPercent := 100.000000000000000000;
    SetEvent(btnAntwortNeu, Self, 'OnClick', 'btnAntwortNeuClick');
    edtNotiz.SetParentComponent(Self);
    edtNotiz.Name := 'edtNotiz';
    edtNotiz.Left := 8;
    edtNotiz.Top := 327;
    edtNotiz.Width := 352;
    edtNotiz.Height := 91;
    edtNotiz.ChildOrder := 29;
    edtNotiz.ElementClassName := 'form-control form-control-sm m-1';
    edtNotiz.ElementFont := efCSS;
    edtNotiz.ElementPosition := epIgnore;
    edtNotiz.HeightPercent := 100.000000000000000000;
    edtNotiz.Lines.BeginUpdate;
    try
      edtNotiz.Lines.Clear;
      edtNotiz.Lines.Add('WebMemo1');
    finally
      edtNotiz.Lines.EndUpdate;
    end;
    edtNotiz.SelLength := 0;
    edtNotiz.SelStart := 0;
    edtNotiz.TabOrder := 5;
    edtNotiz.WidthStyle := ssPercent;
    edtNotiz.WidthPercent := 80.000000000000000000;
    btnAntwortSpeichern.SetParentComponent(Self);
    btnAntwortSpeichern.Name := 'btnAntwortSpeichern';
    btnAntwortSpeichern.Left := 8;
    btnAntwortSpeichern.Top := 449;
    btnAntwortSpeichern.Width := 96;
    btnAntwortSpeichern.Height := 25;
    btnAntwortSpeichern.Caption := 'Antwort speichern';
    btnAntwortSpeichern.ChildOrder := 6;
    btnAntwortSpeichern.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnAntwortSpeichern.ElementFont := efCSS;
    btnAntwortSpeichern.ElementPosition := epIgnore;
    btnAntwortSpeichern.HeightStyle := ssAuto;
    btnAntwortSpeichern.HeightPercent := 100.000000000000000000;
    btnAntwortSpeichern.WidthStyle := ssAuto;
    btnAntwortSpeichern.WidthPercent := 100.000000000000000000;
    SetEvent(btnAntwortSpeichern, Self, 'OnClick', 'btnAntwortSpeichernClick');
    checkBenachrichtigung.SetParentComponent(Self);
    checkBenachrichtigung.Name := 'checkBenachrichtigung';
    checkBenachrichtigung.Left := 24;
    checkBenachrichtigung.Top := 141;
    checkBenachrichtigung.Width := 50;
    checkBenachrichtigung.Height := 22;
    checkBenachrichtigung.Checked := True;
    checkBenachrichtigung.ChildOrder := 10;
    checkBenachrichtigung.ElementClassName := 'custom-control custom-checkbox m-1';
    checkBenachrichtigung.ElementButtonClassName := 'custom-control-input';
    checkBenachrichtigung.ElementLabelClassName := 'custom-control-label';
    checkBenachrichtigung.ElementFont := efCSS;
    checkBenachrichtigung.ElementPosition := epIgnore;
    checkBenachrichtigung.HeightStyle := ssAuto;
    checkBenachrichtigung.HeightPercent := 100.000000000000000000;
    checkBenachrichtigung.State := cbChecked;
    checkBenachrichtigung.WidthPercent := 100.000000000000000000;
    Container4.SetParentComponent(Self);
    Container4.Name := 'Container4';
    Container4.Left := 0;
    Container4.Top := 141;
    Container4.Width := 169;
    Container4.Height := 41;
    Container4.ElementClassName := 'd-flex flex-wrap m-1';
    Container4.HeightStyle := ssAuto;
    Container4.WidthStyle := ssAuto;
    Container4.ChildOrder := 5;
    Container4.ElementFont := efCSS;
    Container4.ElementPosition := epIgnore;
    Container5.SetParentComponent(Self);
    Container5.Name := 'Container5';
    Container5.Left := 304;
    Container5.Top := 191;
    Container5.Width := 169;
    Container5.Height := 41;
    Container5.ElementClassName := 'd-flex flex-wrap m-1 border border-dark';
    Container5.HeightStyle := ssAuto;
    Container5.WidthStyle := ssAuto;
    Container5.ChildOrder := 5;
    Container5.ElementFont := efCSS;
    Container5.ElementPosition := epIgnore;
    xdsTicket.SetParentComponent(Self);
    xdsTicket.Name := 'xdsTicket';
    xdsTicket.AfterApplyUpdates := xdsTicketAfterApplyUpdates;
    xdsTicket.AfterOpen := xdsTicketAfterOpen;
    xdsTicket.BeforePost := xdsTicketBeforePost;
    xdsTicket.AfterPost := xdsTicketAfterPost;
    xdsTicket.EntitySetName := 'ITS_TicketMain';
    xdsTicket.Connection := DM2.XDataWebConnection1;
    xdsTicket.SubpropsDepth := 1;
    xdsTicket.QueryString := '$expand=Kundennummer,Status,Kategorie';
    xdsTicket.QueryTop := 1;
    xdsTicket.Left := 45;
    xdsTicket.Top := 229;
    xdsTicketKundennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummer.Name := 'xdsTicketKundennummer';
    xdsTicketKundennummer.FieldName := 'Kundennummer';
    xdsTicketKundennummerZahlungsbedingung.SetParentComponent(xdsTicket);
    xdsTicketKundennummerZahlungsbedingung.Name := 'xdsTicketKundennummerZahlungsbedingung';
    xdsTicketKundennummerZahlungsbedingung.FieldName := 'Kundennummer.Zahlungsbedingung';
    xdsTicketKundennummerKundennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKundennummer.Name := 'xdsTicketKundennummerKundennummer';
    xdsTicketKundennummerKundennummer.FieldName := 'Kundennummer.Kundennummer';
    xdsTicketKundennummerKundennummer.Size := 13;
    xdsTicketKundennummerGruppeKunden.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGruppeKunden.Name := 'xdsTicketKundennummerGruppeKunden';
    xdsTicketKundennummerGruppeKunden.FieldName := 'Kundennummer.GruppeKunden';
    xdsTicketKundennummerGruppeLieferanten.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGruppeLieferanten.Name := 'xdsTicketKundennummerGruppeLieferanten';
    xdsTicketKundennummerGruppeLieferanten.FieldName := 'Kundennummer.GruppeLieferanten';
    xdsTicketKundennummerGruppeSonstige.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGruppeSonstige.Name := 'xdsTicketKundennummerGruppeSonstige';
    xdsTicketKundennummerGruppeSonstige.FieldName := 'Kundennummer.GruppeSonstige';
    xdsTicketKundennummerGruppeNichtkunden.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGruppeNichtkunden.Name := 'xdsTicketKundennummerGruppeNichtkunden';
    xdsTicketKundennummerGruppeNichtkunden.FieldName := 'Kundennummer.GruppeNichtkunden';
    xdsTicketKundennummerKontaktgruppe.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKontaktgruppe.Name := 'xdsTicketKundennummerKontaktgruppe';
    xdsTicketKundennummerKontaktgruppe.FieldName := 'Kundennummer.Kontaktgruppe';
    xdsTicketKundennummerKontaktgruppe.Size := 50;
    xdsTicketKundennummerNachname.SetParentComponent(xdsTicket);
    xdsTicketKundennummerNachname.Name := 'xdsTicketKundennummerNachname';
    xdsTicketKundennummerNachname.FieldName := 'Kundennummer.Nachname';
    xdsTicketKundennummerNachname.Size := 40;
    xdsTicketKundennummerVorname.SetParentComponent(xdsTicket);
    xdsTicketKundennummerVorname.Name := 'xdsTicketKundennummerVorname';
    xdsTicketKundennummerVorname.FieldName := 'Kundennummer.Vorname';
    xdsTicketKundennummerVorname.Size := 40;
    xdsTicketKundennummerAdresszeile2.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAdresszeile2.Name := 'xdsTicketKundennummerAdresszeile2';
    xdsTicketKundennummerAdresszeile2.FieldName := 'Kundennummer.Adresszeile2';
    xdsTicketKundennummerAdresszeile2.Size := 40;
    xdsTicketKundennummerAdresszeile3.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAdresszeile3.Name := 'xdsTicketKundennummerAdresszeile3';
    xdsTicketKundennummerAdresszeile3.FieldName := 'Kundennummer.Adresszeile3';
    xdsTicketKundennummerAdresszeile3.Size := 40;
    xdsTicketKundennummerStrasse.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStrasse.Name := 'xdsTicketKundennummerStrasse';
    xdsTicketKundennummerStrasse.FieldName := 'Kundennummer.Strasse';
    xdsTicketKundennummerStrasse.Size := 40;
    xdsTicketKundennummerPostleitzahl.SetParentComponent(xdsTicket);
    xdsTicketKundennummerPostleitzahl.Name := 'xdsTicketKundennummerPostleitzahl';
    xdsTicketKundennummerPostleitzahl.FieldName := 'Kundennummer.Postleitzahl';
    xdsTicketKundennummerPostleitzahl.Size := 10;
    xdsTicketKundennummerOrt.SetParentComponent(xdsTicket);
    xdsTicketKundennummerOrt.Name := 'xdsTicketKundennummerOrt';
    xdsTicketKundennummerOrt.FieldName := 'Kundennummer.Ort';
    xdsTicketKundennummerOrt.Size := 40;
    xdsTicketKundennummerLaenderkuerzel.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLaenderkuerzel.Name := 'xdsTicketKundennummerLaenderkuerzel';
    xdsTicketKundennummerLaenderkuerzel.FieldName := 'Kundennummer.Laenderkuerzel';
    xdsTicketKundennummerLaenderkuerzel.Size := 5;
    xdsTicketKundennummerLand.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLand.Name := 'xdsTicketKundennummerLand';
    xdsTicketKundennummerLand.FieldName := 'Kundennummer.Land';
    xdsTicketKundennummerLand.Size := 40;
    xdsTicketKundennummerLaenderkennzeichen.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLaenderkennzeichen.Name := 'xdsTicketKundennummerLaenderkennzeichen';
    xdsTicketKundennummerLaenderkennzeichen.FieldName := 'Kundennummer.Laenderkennzeichen';
    xdsTicketKundennummerAdressanrede.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAdressanrede.Name := 'xdsTicketKundennummerAdressanrede';
    xdsTicketKundennummerAdressanrede.FieldName := 'Kundennummer.Adressanrede';
    xdsTicketKundennummerAdressanrede.Size := 15;
    xdsTicketKundennummerBriefanrede1.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBriefanrede1.Name := 'xdsTicketKundennummerBriefanrede1';
    xdsTicketKundennummerBriefanrede1.FieldName := 'Kundennummer.Briefanrede1';
    xdsTicketKundennummerBriefanrede1.Size := 255;
    xdsTicketKundennummerBriefanrede2.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBriefanrede2.Name := 'xdsTicketKundennummerBriefanrede2';
    xdsTicketKundennummerBriefanrede2.FieldName := 'Kundennummer.Briefanrede2';
    xdsTicketKundennummerBriefanrede2.Size := 40;
    xdsTicketKundennummerAdresseBild.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAdresseBild.Name := 'xdsTicketKundennummerAdresseBild';
    xdsTicketKundennummerAdresseBild.FieldName := 'Kundennummer.AdresseBild';
    xdsTicketKundennummerAdresseBild.Size := 255;
    xdsTicketKundennummerLieferanschrift.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLieferanschrift.Name := 'xdsTicketKundennummerLieferanschrift';
    xdsTicketKundennummerLieferanschrift.FieldName := 'Kundennummer.Lieferanschrift';
    xdsTicketKundennummerLieferanschrift.Size := 255;
    xdsTicketKundennummerGeburtsdatum.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGeburtsdatum.Name := 'xdsTicketKundennummerGeburtsdatum';
    xdsTicketKundennummerGeburtsdatum.FieldName := 'Kundennummer.Geburtsdatum';
    xdsTicketKundennummerTelefonNummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTelefonNummer.Name := 'xdsTicketKundennummerTelefonNummer';
    xdsTicketKundennummerTelefonNummer.FieldName := 'Kundennummer.TelefonNummer';
    xdsTicketKundennummerTelefonNummer.Size := 25;
    xdsTicketKundennummerTelefaxNummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTelefaxNummer.Name := 'xdsTicketKundennummerTelefaxNummer';
    xdsTicketKundennummerTelefaxNummer.FieldName := 'Kundennummer.TelefaxNummer';
    xdsTicketKundennummerTelefaxNummer.Size := 25;
    xdsTicketKundennummerMobilTelefon.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMobilTelefon.Name := 'xdsTicketKundennummerMobilTelefon';
    xdsTicketKundennummerMobilTelefon.FieldName := 'Kundennummer.MobilTelefon';
    xdsTicketKundennummerMobilTelefon.Size := 25;
    xdsTicketKundennummerEMail.SetParentComponent(xdsTicket);
    xdsTicketKundennummerEMail.Name := 'xdsTicketKundennummerEMail';
    xdsTicketKundennummerEMail.FieldName := 'Kundennummer.EMail';
    xdsTicketKundennummerEMail.Size := 50;
    xdsTicketKundennummerInternet.SetParentComponent(xdsTicket);
    xdsTicketKundennummerInternet.Name := 'xdsTicketKundennummerInternet';
    xdsTicketKundennummerInternet.FieldName := 'Kundennummer.Internet';
    xdsTicketKundennummerInternet.Size := 50;
    xdsTicketKundennummerUmsatzsteuerID.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzsteuerID.Name := 'xdsTicketKundennummerUmsatzsteuerID';
    xdsTicketKundennummerUmsatzsteuerID.FieldName := 'Kundennummer.UmsatzsteuerID';
    xdsTicketKundennummerUmsatzsteuerausweis.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzsteuerausweis.Name := 'xdsTicketKundennummerUmsatzsteuerausweis';
    xdsTicketKundennummerUmsatzsteuerausweis.FieldName := 'Kundennummer.Umsatzsteuerausweis';
    xdsTicketKundennummerBemerkungen.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBemerkungen.Name := 'xdsTicketKundennummerBemerkungen';
    xdsTicketKundennummerBemerkungen.FieldName := 'Kundennummer.Bemerkungen';
    xdsTicketKundennummerBemerkungen.Size := 255;
    xdsTicketKundennummerBranche.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBranche.Name := 'xdsTicketKundennummerBranche';
    xdsTicketKundennummerBranche.FieldName := 'Kundennummer.Branche';
    xdsTicketKundennummerBranche.Size := 50;
    xdsTicketKundennummerSelektiert1.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSelektiert1.Name := 'xdsTicketKundennummerSelektiert1';
    xdsTicketKundennummerSelektiert1.FieldName := 'Kundennummer.Selektiert1';
    xdsTicketKundennummerSelektiert2.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSelektiert2.Name := 'xdsTicketKundennummerSelektiert2';
    xdsTicketKundennummerSelektiert2.FieldName := 'Kundennummer.Selektiert2';
    xdsTicketKundennummerSelektiert3.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSelektiert3.Name := 'xdsTicketKundennummerSelektiert3';
    xdsTicketKundennummerSelektiert3.FieldName := 'Kundennummer.Selektiert3';
    xdsTicketKundennummerTransportbedingung.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTransportbedingung.Name := 'xdsTicketKundennummerTransportbedingung';
    xdsTicketKundennummerTransportbedingung.FieldName := 'Kundennummer.Transportbedingung';
    xdsTicketKundennummerTransportbedingung.Size := 100;
    xdsTicketKundennummerKilometer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKilometer.Name := 'xdsTicketKundennummerKilometer';
    xdsTicketKundennummerKilometer.FieldName := 'Kundennummer.Kilometer';
    xdsTicketKundennummerRabattsatz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRabattsatz.Name := 'xdsTicketKundennummerRabattsatz';
    xdsTicketKundennummerRabattsatz.FieldName := 'Kundennummer.Rabattsatz';
    xdsTicketKundennummerStundensatz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStundensatz.Name := 'xdsTicketKundennummerStundensatz';
    xdsTicketKundennummerStundensatz.FieldName := 'Kundennummer.Stundensatz';
    xdsTicketKundennummerKontonummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKontonummer.Name := 'xdsTicketKundennummerKontonummer';
    xdsTicketKundennummerKontonummer.FieldName := 'Kundennummer.Kontonummer';
    xdsTicketKundennummerKontonummer.Size := 50;
    xdsTicketKundennummerBank.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBank.Name := 'xdsTicketKundennummerBank';
    xdsTicketKundennummerBank.FieldName := 'Kundennummer.Bank';
    xdsTicketKundennummerBank.Size := 50;
    xdsTicketKundennummerBankleitzahl.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBankleitzahl.Name := 'xdsTicketKundennummerBankleitzahl';
    xdsTicketKundennummerBankleitzahl.FieldName := 'Kundennummer.Bankleitzahl';
    xdsTicketKundennummerKontoinhaber.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKontoinhaber.Name := 'xdsTicketKundennummerKontoinhaber';
    xdsTicketKundennummerKontoinhaber.FieldName := 'Kundennummer.Kontoinhaber';
    xdsTicketKundennummerKontoinhaber.Size := 50;
    xdsTicketKundennummerBetreuer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBetreuer.Name := 'xdsTicketKundennummerBetreuer';
    xdsTicketKundennummerBetreuer.FieldName := 'Kundennummer.Betreuer';
    xdsTicketKundennummerBetreuer.Size := 50;
    xdsTicketKundennummerQuelle.SetParentComponent(xdsTicket);
    xdsTicketKundennummerQuelle.Name := 'xdsTicketKundennummerQuelle';
    xdsTicketKundennummerQuelle.FieldName := 'Kundennummer.Quelle';
    xdsTicketKundennummerQuelle.Size := 100;
    xdsTicketKundennummerSuchmerkmal.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSuchmerkmal.Name := 'xdsTicketKundennummerSuchmerkmal';
    xdsTicketKundennummerSuchmerkmal.FieldName := 'Kundennummer.Suchmerkmal';
    xdsTicketKundennummerSuchmerkmal.Size := 250;
    xdsTicketKundennummerWarenkreditlimit.SetParentComponent(xdsTicket);
    xdsTicketKundennummerWarenkreditlimit.Name := 'xdsTicketKundennummerWarenkreditlimit';
    xdsTicketKundennummerWarenkreditlimit.FieldName := 'Kundennummer.Warenkreditlimit';
    xdsTicketKundennummerWarenkreditgesperrt.SetParentComponent(xdsTicket);
    xdsTicketKundennummerWarenkreditgesperrt.Name := 'xdsTicketKundennummerWarenkreditgesperrt';
    xdsTicketKundennummerWarenkreditgesperrt.FieldName := 'Kundennummer.Warenkreditgesperrt';
    xdsTicketKundennummerKundennummerFremd.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKundennummerFremd.Name := 'xdsTicketKundennummerKundennummerFremd';
    xdsTicketKundennummerKundennummerFremd.FieldName := 'Kundennummer.KundennummerFremd';
    xdsTicketKundennummerKeinNewsletter.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKeinNewsletter.Name := 'xdsTicketKundennummerKeinNewsletter';
    xdsTicketKundennummerKeinNewsletter.FieldName := 'Kundennummer.KeinNewsletter';
    xdsTicketKundennummerDebitorennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerDebitorennummer.Name := 'xdsTicketKundennummerDebitorennummer';
    xdsTicketKundennummerDebitorennummer.FieldName := 'Kundennummer.Debitorennummer';
    xdsTicketKundennummerDebitorennummer.Size := 13;
    xdsTicketKundennummerKreditorennummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditorennummer.Name := 'xdsTicketKundennummerKreditorennummer';
    xdsTicketKundennummerKreditorennummer.FieldName := 'Kundennummer.Kreditorennummer';
    xdsTicketKundennummerKreditorennummer.Size := 13;
    xdsTicketKundennummerRabattstufe.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRabattstufe.Name := 'xdsTicketKundennummerRabattstufe';
    xdsTicketKundennummerRabattstufe.FieldName := 'Kundennummer.Rabattstufe';
    xdsTicketKundennummerRabattstufe.Size := 15;
    xdsTicketKundennummerTelefonAlternativ.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTelefonAlternativ.Name := 'xdsTicketKundennummerTelefonAlternativ';
    xdsTicketKundennummerTelefonAlternativ.FieldName := 'Kundennummer.TelefonAlternativ';
    xdsTicketKundennummerTelefonAlternativ.Size := 50;
    xdsTicketKundennummerKostentraeger.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKostentraeger.Name := 'xdsTicketKundennummerKostentraeger';
    xdsTicketKundennummerKostentraeger.FieldName := 'Kundennummer.Kostentraeger';
    xdsTicketKundennummerKostentraeger.Size := 13;
    xdsTicketKundennummerIBAN.SetParentComponent(xdsTicket);
    xdsTicketKundennummerIBAN.Name := 'xdsTicketKundennummerIBAN';
    xdsTicketKundennummerIBAN.FieldName := 'Kundennummer.IBAN';
    xdsTicketKundennummerIBAN.Size := 50;
    xdsTicketKundennummerBIC.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBIC.Name := 'xdsTicketKundennummerBIC';
    xdsTicketKundennummerBIC.FieldName := 'Kundennummer.BIC';
    xdsTicketKundennummerEmailkonto.SetParentComponent(xdsTicket);
    xdsTicketKundennummerEmailkonto.Name := 'xdsTicketKundennummerEmailkonto';
    xdsTicketKundennummerEmailkonto.FieldName := 'Kundennummer.Emailkonto';
    xdsTicketKundennummerEmailkonto.Size := 50;
    xdsTicketKundennummerBenutzername.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBenutzername.Name := 'xdsTicketKundennummerBenutzername';
    xdsTicketKundennummerBenutzername.FieldName := 'Kundennummer.Benutzername';
    xdsTicketKundennummerBenutzername.Size := 50;
    xdsTicketKundennummerPasswort.SetParentComponent(xdsTicket);
    xdsTicketKundennummerPasswort.Name := 'xdsTicketKundennummerPasswort';
    xdsTicketKundennummerPasswort.FieldName := 'Kundennummer.Passwort';
    xdsTicketKundennummerPasswort.Size := 25;
    xdsTicketKundennummerExportOutlook.SetParentComponent(xdsTicket);
    xdsTicketKundennummerExportOutlook.Name := 'xdsTicketKundennummerExportOutlook';
    xdsTicketKundennummerExportOutlook.FieldName := 'Kundennummer.ExportOutlook';
    xdsTicketKundennummerNichtInListeAnzeigen.SetParentComponent(xdsTicket);
    xdsTicketKundennummerNichtInListeAnzeigen.Name := 'xdsTicketKundennummerNichtInListeAnzeigen';
    xdsTicketKundennummerNichtInListeAnzeigen.FieldName := 'Kundennummer.NichtInListeAnzeigen';
    xdsTicketKundennummerKreditkarteArt.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkarteArt.Name := 'xdsTicketKundennummerKreditkarteArt';
    xdsTicketKundennummerKreditkarteArt.FieldName := 'Kundennummer.KreditkarteArt';
    xdsTicketKundennummerKreditkarteArt.Size := 30;
    xdsTicketKundennummerKreditkarteInhaber.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkarteInhaber.Name := 'xdsTicketKundennummerKreditkarteInhaber';
    xdsTicketKundennummerKreditkarteInhaber.FieldName := 'Kundennummer.KreditkarteInhaber';
    xdsTicketKundennummerKreditkarteInhaber.Size := 50;
    xdsTicketKundennummerKreditkarteNummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkarteNummer.Name := 'xdsTicketKundennummerKreditkarteNummer';
    xdsTicketKundennummerKreditkarteNummer.FieldName := 'Kundennummer.KreditkarteNummer';
    xdsTicketKundennummerKreditkarteGueltigMonat.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkarteGueltigMonat.Name := 'xdsTicketKundennummerKreditkarteGueltigMonat';
    xdsTicketKundennummerKreditkarteGueltigMonat.FieldName := 'Kundennummer.KreditkarteGueltigMonat';
    xdsTicketKundennummerKreditkarteGueltigMonat.Size := 2;
    xdsTicketKundennummerKreditkarteGueltigJahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkarteGueltigJahr.Name := 'xdsTicketKundennummerKreditkarteGueltigJahr';
    xdsTicketKundennummerKreditkarteGueltigJahr.FieldName := 'Kundennummer.KreditkarteGueltigJahr';
    xdsTicketKundennummerKreditkartePruefziffer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKreditkartePruefziffer.Name := 'xdsTicketKundennummerKreditkartePruefziffer';
    xdsTicketKundennummerKreditkartePruefziffer.FieldName := 'Kundennummer.KreditkartePruefziffer';
    xdsTicketKundennummerKreditkartePruefziffer.Size := 10;
    xdsTicketKundennummerDatumNeu.SetParentComponent(xdsTicket);
    xdsTicketKundennummerDatumNeu.Name := 'xdsTicketKundennummerDatumNeu';
    xdsTicketKundennummerDatumNeu.FieldName := 'Kundennummer.DatumNeu';
    xdsTicketKundennummerDatumgeaendert.SetParentComponent(xdsTicket);
    xdsTicketKundennummerDatumgeaendert.Name := 'xdsTicketKundennummerDatumgeaendert';
    xdsTicketKundennummerDatumgeaendert.FieldName := 'Kundennummer.Datumgeaendert';
    xdsTicketKundennummerTitel.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTitel.Name := 'xdsTicketKundennummerTitel';
    xdsTicketKundennummerTitel.FieldName := 'Kundennummer.Titel';
    xdsTicketKundennummerStundensatzMontage.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStundensatzMontage.Name := 'xdsTicketKundennummerStundensatzMontage';
    xdsTicketKundennummerStundensatzMontage.FieldName := 'Kundennummer.StundensatzMontage';
    xdsTicketKundennummerStdMontageU25.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdMontageU25.Name := 'xdsTicketKundennummerStdMontageU25';
    xdsTicketKundennummerStdMontageU25.FieldName := 'Kundennummer.StdMontageU25';
    xdsTicketKundennummerStdMontageU50.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdMontageU50.Name := 'xdsTicketKundennummerStdMontageU50';
    xdsTicketKundennummerStdMontageU50.FieldName := 'Kundennummer.StdMontageU50';
    xdsTicketKundennummerStdMontageU70.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdMontageU70.Name := 'xdsTicketKundennummerStdMontageU70';
    xdsTicketKundennummerStdMontageU70.FieldName := 'Kundennummer.StdMontageU70';
    xdsTicketKundennummerStdMontageU100.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdMontageU100.Name := 'xdsTicketKundennummerStdMontageU100';
    xdsTicketKundennummerStdMontageU100.FieldName := 'Kundennummer.StdMontageU100';
    xdsTicketKundennummerStdMontageU150.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdMontageU150.Name := 'xdsTicketKundennummerStdMontageU150';
    xdsTicketKundennummerStdMontageU150.FieldName := 'Kundennummer.StdMontageU150';
    xdsTicketKundennummerStundensatzWerkstatt.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStundensatzWerkstatt.Name := 'xdsTicketKundennummerStundensatzWerkstatt';
    xdsTicketKundennummerStundensatzWerkstatt.FieldName := 'Kundennummer.StundensatzWerkstatt';
    xdsTicketKundennummerStdWerkstattU25.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdWerkstattU25.Name := 'xdsTicketKundennummerStdWerkstattU25';
    xdsTicketKundennummerStdWerkstattU25.FieldName := 'Kundennummer.StdWerkstattU25';
    xdsTicketKundennummerStdWerkstattU50.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdWerkstattU50.Name := 'xdsTicketKundennummerStdWerkstattU50';
    xdsTicketKundennummerStdWerkstattU50.FieldName := 'Kundennummer.StdWerkstattU50';
    xdsTicketKundennummerStdWerkstattU70.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdWerkstattU70.Name := 'xdsTicketKundennummerStdWerkstattU70';
    xdsTicketKundennummerStdWerkstattU70.FieldName := 'Kundennummer.StdWerkstattU70';
    xdsTicketKundennummerStdWerkstattU100.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdWerkstattU100.Name := 'xdsTicketKundennummerStdWerkstattU100';
    xdsTicketKundennummerStdWerkstattU100.FieldName := 'Kundennummer.StdWerkstattU100';
    xdsTicketKundennummerStdWerkstattU150.SetParentComponent(xdsTicket);
    xdsTicketKundennummerStdWerkstattU150.Name := 'xdsTicketKundennummerStdWerkstattU150';
    xdsTicketKundennummerStdWerkstattU150.FieldName := 'Kundennummer.StdWerkstattU150';
    xdsTicketKundennummerArchivReferenz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerArchivReferenz.Name := 'xdsTicketKundennummerArchivReferenz';
    xdsTicketKundennummerArchivReferenz.FieldName := 'Kundennummer.ArchivReferenz';
    xdsTicketKundennummerArchivReferenz.Size := 55;
    xdsTicketKundennummerErloesKontoUST1.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST1.Name := 'xdsTicketKundennummerErloesKontoUST1';
    xdsTicketKundennummerErloesKontoUST1.FieldName := 'Kundennummer.ErloesKontoUST1';
    xdsTicketKundennummerErloesKontoUST1.Size := 10;
    xdsTicketKundennummerErloesKontoUST2.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST2.Name := 'xdsTicketKundennummerErloesKontoUST2';
    xdsTicketKundennummerErloesKontoUST2.FieldName := 'Kundennummer.ErloesKontoUST2';
    xdsTicketKundennummerErloesKontoUST2.Size := 10;
    xdsTicketKundennummerErloesKontoUST3.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST3.Name := 'xdsTicketKundennummerErloesKontoUST3';
    xdsTicketKundennummerErloesKontoUST3.FieldName := 'Kundennummer.ErloesKontoUST3';
    xdsTicketKundennummerErloesKontoUST3.Size := 10;
    xdsTicketKundennummerGebKal.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGebKal.Name := 'xdsTicketKundennummerGebKal';
    xdsTicketKundennummerGebKal.FieldName := 'Kundennummer.GebKal';
    xdsTicketKundennummerEmailversand.SetParentComponent(xdsTicket);
    xdsTicketKundennummerEmailversand.Name := 'xdsTicketKundennummerEmailversand';
    xdsTicketKundennummerEmailversand.FieldName := 'Kundennummer.Emailversand';
    xdsTicketKundennummerMahnspesen.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMahnspesen.Name := 'xdsTicketKundennummerMahnspesen';
    xdsTicketKundennummerMahnspesen.FieldName := 'Kundennummer.Mahnspesen';
    xdsTicketKundennummerRechnungSchluss.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRechnungSchluss.Name := 'xdsTicketKundennummerRechnungSchluss';
    xdsTicketKundennummerRechnungSchluss.FieldName := 'Kundennummer.RechnungSchluss';
    xdsTicketKundennummerRechnungSchluss.Size := 255;
    xdsTicketKundennummerBenutzerNeu.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBenutzerNeu.Name := 'xdsTicketKundennummerBenutzerNeu';
    xdsTicketKundennummerBenutzerNeu.FieldName := 'Kundennummer.BenutzerNeu';
    xdsTicketKundennummerBenutzerNeu.Size := 50;
    xdsTicketKundennummerBenutzerGeaendert.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBenutzerGeaendert.Name := 'xdsTicketKundennummerBenutzerGeaendert';
    xdsTicketKundennummerBenutzerGeaendert.FieldName := 'Kundennummer.BenutzerGeaendert';
    xdsTicketKundennummerBenutzerGeaendert.Size := 50;
    xdsTicketKundennummerBelegsprache.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBelegsprache.Name := 'xdsTicketKundennummerBelegsprache';
    xdsTicketKundennummerBelegsprache.FieldName := 'Kundennummer.Belegsprache';
    xdsTicketKundennummerBelegsprache.Size := 10;
    xdsTicketKundennummerkmSatz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerkmSatz.Name := 'xdsTicketKundennummerkmSatz';
    xdsTicketKundennummerkmSatz.FieldName := 'Kundennummer.kmSatz';
    xdsTicketKundennummerKundenklassetext.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKundenklassetext.Name := 'xdsTicketKundennummerKundenklassetext';
    xdsTicketKundennummerKundenklassetext.FieldName := 'Kundennummer.Kundenklassetext';
    xdsTicketKundennummerKundenklassetext.Size := 50;
    xdsTicketKundennummerKundenklasseFarbe.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKundenklasseFarbe.Name := 'xdsTicketKundennummerKundenklasseFarbe';
    xdsTicketKundennummerKundenklasseFarbe.FieldName := 'Kundennummer.KundenklasseFarbe';
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.Name := 'xdsTicketKundennummerAbweichenderRechnungsEmpfaenger';
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.FieldName := 'Kundennummer.AbweichenderRechnungsEmpfaenger';
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.Size := 13;
    xdsTicketKundennummerProtokoll.SetParentComponent(xdsTicket);
    xdsTicketKundennummerProtokoll.Name := 'xdsTicketKundennummerProtokoll';
    xdsTicketKundennummerProtokoll.FieldName := 'Kundennummer.Protokoll';
    xdsTicketKundennummerProtokoll.Size := 255;
    xdsTicketKundennummerILNTyp1.SetParentComponent(xdsTicket);
    xdsTicketKundennummerILNTyp1.Name := 'xdsTicketKundennummerILNTyp1';
    xdsTicketKundennummerILNTyp1.FieldName := 'Kundennummer.ILNTyp1';
    xdsTicketKundennummerILNTyp1.Size := 13;
    xdsTicketKundennummerILNTyp2.SetParentComponent(xdsTicket);
    xdsTicketKundennummerILNTyp2.Name := 'xdsTicketKundennummerILNTyp2';
    xdsTicketKundennummerILNTyp2.FieldName := 'Kundennummer.ILNTyp2';
    xdsTicketKundennummerILNTyp2.Size := 13;
    xdsTicketKundennummerKontaktGUID.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKontaktGUID.Name := 'xdsTicketKundennummerKontaktGUID';
    xdsTicketKundennummerKontaktGUID.FieldName := 'Kundennummer.KontaktGUID';
    xdsTicketKundennummerKontaktGUID.Size := 38;
    xdsTicketKundennummerPLZGUID.SetParentComponent(xdsTicket);
    xdsTicketKundennummerPLZGUID.Name := 'xdsTicketKundennummerPLZGUID';
    xdsTicketKundennummerPLZGUID.FieldName := 'Kundennummer.PLZGUID';
    xdsTicketKundennummerPLZGUID.Size := 38;
    xdsTicketKundennummerPreislistenVariantePakete.SetParentComponent(xdsTicket);
    xdsTicketKundennummerPreislistenVariantePakete.Name := 'xdsTicketKundennummerPreislistenVariantePakete';
    xdsTicketKundennummerPreislistenVariantePakete.FieldName := 'Kundennummer.PreislistenVariantePakete';
    xdsTicketKundennummerPreislistenVariantePakete.Size := 50;
    xdsTicketKundennummerSchluesselRechnungslauf.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSchluesselRechnungslauf.Name := 'xdsTicketKundennummerSchluesselRechnungslauf';
    xdsTicketKundennummerSchluesselRechnungslauf.FieldName := 'Kundennummer.SchluesselRechnungslauf';
    xdsTicketKundennummerSchluesselRechnungslauf.Size := 50;
    xdsTicketKundennummerRechnungEmail.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRechnungEmail.Name := 'xdsTicketKundennummerRechnungEmail';
    xdsTicketKundennummerRechnungEmail.FieldName := 'Kundennummer.RechnungEmail';
    xdsTicketKundennummerRechnungEmail.Size := 50;
    xdsTicketKundennummerZahlungsbedingungEK.SetParentComponent(xdsTicket);
    xdsTicketKundennummerZahlungsbedingungEK.Name := 'xdsTicketKundennummerZahlungsbedingungEK';
    xdsTicketKundennummerZahlungsbedingungEK.FieldName := 'Kundennummer.ZahlungsbedingungEK';
    xdsTicketKundennummerTransportbedingungEK.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTransportbedingungEK.Name := 'xdsTicketKundennummerTransportbedingungEK';
    xdsTicketKundennummerTransportbedingungEK.FieldName := 'Kundennummer.TransportbedingungEK';
    xdsTicketKundennummerTransportbedingungEK.Size := 100;
    xdsTicketKundennummerRabattsatzEK.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRabattsatzEK.Name := 'xdsTicketKundennummerRabattsatzEK';
    xdsTicketKundennummerRabattsatzEK.FieldName := 'Kundennummer.RabattsatzEK';
    xdsTicketKundennummerVertreterMatchcode.SetParentComponent(xdsTicket);
    xdsTicketKundennummerVertreterMatchcode.Name := 'xdsTicketKundennummerVertreterMatchcode';
    xdsTicketKundennummerVertreterMatchcode.FieldName := 'Kundennummer.VertreterMatchcode';
    xdsTicketKundennummerVertreterMatchcode.Size := 50;
    xdsTicketKundennummerVertreterProvisionssatz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerVertreterProvisionssatz.Name := 'xdsTicketKundennummerVertreterProvisionssatz';
    xdsTicketKundennummerVertreterProvisionssatz.FieldName := 'Kundennummer.VertreterProvisionssatz';
    xdsTicketKundennummerUmsatzVKJahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzVKJahr.Name := 'xdsTicketKundennummerUmsatzVKJahr';
    xdsTicketKundennummerUmsatzVKJahr.FieldName := 'Kundennummer.UmsatzVKJahr';
    xdsTicketKundennummerUmsatzVKVorjahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzVKVorjahr.Name := 'xdsTicketKundennummerUmsatzVKVorjahr';
    xdsTicketKundennummerUmsatzVKVorjahr.FieldName := 'Kundennummer.UmsatzVKVorjahr';
    xdsTicketKundennummerUmsatzEKJahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzEKJahr.Name := 'xdsTicketKundennummerUmsatzEKJahr';
    xdsTicketKundennummerUmsatzEKJahr.FieldName := 'Kundennummer.UmsatzEKJahr';
    xdsTicketKundennummerUmsatzEKVorjahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUmsatzEKVorjahr.Name := 'xdsTicketKundennummerUmsatzEKVorjahr';
    xdsTicketKundennummerUmsatzEKVorjahr.FieldName := 'Kundennummer.UmsatzEKVorjahr';
    xdsTicketKundennummerSteuernummer.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSteuernummer.Name := 'xdsTicketKundennummerSteuernummer';
    xdsTicketKundennummerSteuernummer.FieldName := 'Kundennummer.Steuernummer';
    xdsTicketKundennummerSteuernummer.Size := 25;
    xdsTicketKundennummerLoginPW.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLoginPW.Name := 'xdsTicketKundennummerLoginPW';
    xdsTicketKundennummerLoginPW.FieldName := 'Kundennummer.LoginPW';
    xdsTicketKundennummerREperFax.SetParentComponent(xdsTicket);
    xdsTicketKundennummerREperFax.Name := 'xdsTicketKundennummerREperFax';
    xdsTicketKundennummerREperFax.FieldName := 'Kundennummer.REperFax';
    xdsTicketKundennummerErreichbarkeit.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErreichbarkeit.Name := 'xdsTicketKundennummerErreichbarkeit';
    xdsTicketKundennummerErreichbarkeit.FieldName := 'Kundennummer.Erreichbarkeit';
    xdsTicketKundennummerErreichbarkeit.Size := 250;
    xdsTicketKundennummerErloesKontoUST4.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST4.Name := 'xdsTicketKundennummerErloesKontoUST4';
    xdsTicketKundennummerErloesKontoUST4.FieldName := 'Kundennummer.ErloesKontoUST4';
    xdsTicketKundennummerErloesKontoUST4.Size := 10;
    xdsTicketKundennummerErloesKontoUST5.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST5.Name := 'xdsTicketKundennummerErloesKontoUST5';
    xdsTicketKundennummerErloesKontoUST5.FieldName := 'Kundennummer.ErloesKontoUST5';
    xdsTicketKundennummerErloesKontoUST5.Size := 10;
    xdsTicketKundennummerErloesKontoUST6.SetParentComponent(xdsTicket);
    xdsTicketKundennummerErloesKontoUST6.Name := 'xdsTicketKundennummerErloesKontoUST6';
    xdsTicketKundennummerErloesKontoUST6.FieldName := 'Kundennummer.ErloesKontoUST6';
    xdsTicketKundennummerErloesKontoUST6.Size := 10;
    xdsTicketKundennummerBesteuerungKey.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBesteuerungKey.Name := 'xdsTicketKundennummerBesteuerungKey';
    xdsTicketKundennummerBesteuerungKey.FieldName := 'Kundennummer.BesteuerungKey';
    xdsTicketKundennummerAuftraegeJahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAuftraegeJahr.Name := 'xdsTicketKundennummerAuftraegeJahr';
    xdsTicketKundennummerAuftraegeJahr.FieldName := 'Kundennummer.AuftraegeJahr';
    xdsTicketKundennummerAuftraegeVorjahr.SetParentComponent(xdsTicket);
    xdsTicketKundennummerAuftraegeVorjahr.Name := 'xdsTicketKundennummerAuftraegeVorjahr';
    xdsTicketKundennummerAuftraegeVorjahr.FieldName := 'Kundennummer.AuftraegeVorjahr';
    xdsTicketKundennummerLieferadresseID.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLieferadresseID.Name := 'xdsTicketKundennummerLieferadresseID';
    xdsTicketKundennummerLieferadresseID.FieldName := 'Kundennummer.LieferadresseID';
    xdsTicketKundennummerUSTIDgeprueft.SetParentComponent(xdsTicket);
    xdsTicketKundennummerUSTIDgeprueft.Name := 'xdsTicketKundennummerUSTIDgeprueft';
    xdsTicketKundennummerUSTIDgeprueft.FieldName := 'Kundennummer.USTIDgeprueft';
    xdsTicketKundennummerKontaktverbund.SetParentComponent(xdsTicket);
    xdsTicketKundennummerKontaktverbund.Name := 'xdsTicketKundennummerKontaktverbund';
    xdsTicketKundennummerKontaktverbund.FieldName := 'Kundennummer.Kontaktverbund';
    xdsTicketKundennummerKontaktverbund.Size := 25;
    xdsTicketKundennummerHinweis.SetParentComponent(xdsTicket);
    xdsTicketKundennummerHinweis.Name := 'xdsTicketKundennummerHinweis';
    xdsTicketKundennummerHinweis.FieldName := 'Kundennummer.Hinweis';
    xdsTicketKundennummerHinweis.Size := 255;
    xdsTicketKundennummerLatitude.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLatitude.Name := 'xdsTicketKundennummerLatitude';
    xdsTicketKundennummerLatitude.FieldName := 'Kundennummer.Latitude';
    xdsTicketKundennummerLongitude.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLongitude.Name := 'xdsTicketKundennummerLongitude';
    xdsTicketKundennummerLongitude.FieldName := 'Kundennummer.Longitude';
    xdsTicketKundennummerkmLuftlinie.SetParentComponent(xdsTicket);
    xdsTicketKundennummerkmLuftlinie.Name := 'xdsTicketKundennummerkmLuftlinie';
    xdsTicketKundennummerkmLuftlinie.FieldName := 'Kundennummer.kmLuftlinie';
    xdsTicketKundennummerGoogleID.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGoogleID.Name := 'xdsTicketKundennummerGoogleID';
    xdsTicketKundennummerGoogleID.FieldName := 'Kundennummer.GoogleID';
    xdsTicketKundennummerGoogleID.Size := 250;
    xdsTicketKundennummerGoogleUpdatedUTC.SetParentComponent(xdsTicket);
    xdsTicketKundennummerGoogleUpdatedUTC.Name := 'xdsTicketKundennummerGoogleUpdatedUTC';
    xdsTicketKundennummerGoogleUpdatedUTC.FieldName := 'Kundennummer.GoogleUpdatedUTC';
    xdsTicketKundennummerBundesland.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBundesland.Name := 'xdsTicketKundennummerBundesland';
    xdsTicketKundennummerBundesland.FieldName := 'Kundennummer.Bundesland';
    xdsTicketKundennummerBundesland.Size := 50;
    xdsTicketKundennummerRegion.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRegion.Name := 'xdsTicketKundennummerRegion';
    xdsTicketKundennummerRegion.FieldName := 'Kundennummer.Region';
    xdsTicketKundennummerRegion.Size := 50;
    xdsTicketKundennummerMandatsreferenz.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMandatsreferenz.Name := 'xdsTicketKundennummerMandatsreferenz';
    xdsTicketKundennummerMandatsreferenz.FieldName := 'Kundennummer.Mandatsreferenz';
    xdsTicketKundennummerMandatsreferenz.Size := 34;
    xdsTicketKundennummerMandatsreferenzVom.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMandatsreferenzVom.Name := 'xdsTicketKundennummerMandatsreferenzVom';
    xdsTicketKundennummerMandatsreferenzVom.FieldName := 'Kundennummer.MandatsreferenzVom';
    xdsTicketKundennummerLastschriftArt.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLastschriftArt.Name := 'xdsTicketKundennummerLastschriftArt';
    xdsTicketKundennummerLastschriftArt.FieldName := 'Kundennummer.LastschriftArt';
    xdsTicketKundennummerLastschriftArt.Size := 2;
    xdsTicketKundennummerMahnsperre.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMahnsperre.Name := 'xdsTicketKundennummerMahnsperre';
    xdsTicketKundennummerMahnsperre.FieldName := 'Kundennummer.Mahnsperre';
    xdsTicketKundennummerSuchbegriff.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSuchbegriff.Name := 'xdsTicketKundennummerSuchbegriff';
    xdsTicketKundennummerSuchbegriff.FieldName := 'Kundennummer.Suchbegriff';
    xdsTicketKundennummerSuchbegriff.Size := 25;
    xdsTicketKundennummerLieferanschriftDaten.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLieferanschriftDaten.Name := 'xdsTicketKundennummerLieferanschriftDaten';
    xdsTicketKundennummerLieferanschriftDaten.FieldName := 'Kundennummer.LieferanschriftDaten';
    xdsTicketKundennummerLieferanschriftDaten.Size := 255;
    xdsTicketKundennummerExportKasse.SetParentComponent(xdsTicket);
    xdsTicketKundennummerExportKasse.Name := 'xdsTicketKundennummerExportKasse';
    xdsTicketKundennummerExportKasse.FieldName := 'Kundennummer.ExportKasse';
    xdsTicketKundennummerLoeschvormerkungDatum.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLoeschvormerkungDatum.Name := 'xdsTicketKundennummerLoeschvormerkungDatum';
    xdsTicketKundennummerLoeschvormerkungDatum.FieldName := 'Kundennummer.LoeschvormerkungDatum';
    xdsTicketKundennummerLoeschvormerkungGrund.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLoeschvormerkungGrund.Name := 'xdsTicketKundennummerLoeschvormerkungGrund';
    xdsTicketKundennummerLoeschvormerkungGrund.FieldName := 'Kundennummer.LoeschvormerkungGrund';
    xdsTicketKundennummerLoeschvormerkungGrund.Size := 250;
    xdsTicketKundennummerPseudonymisiert.SetParentComponent(xdsTicket);
    xdsTicketKundennummerPseudonymisiert.Name := 'xdsTicketKundennummerPseudonymisiert';
    xdsTicketKundennummerPseudonymisiert.FieldName := 'Kundennummer.Pseudonymisiert';
    xdsTicketKundennummerPseudonymisiert.Size := 255;
    xdsTicketKundennummerLoginAktiv.SetParentComponent(xdsTicket);
    xdsTicketKundennummerLoginAktiv.Name := 'xdsTicketKundennummerLoginAktiv';
    xdsTicketKundennummerLoginAktiv.FieldName := 'Kundennummer.LoginAktiv';
    xdsTicketKundennummerSonstigeDaten.SetParentComponent(xdsTicket);
    xdsTicketKundennummerSonstigeDaten.Name := 'xdsTicketKundennummerSonstigeDaten';
    xdsTicketKundennummerSonstigeDaten.FieldName := 'Kundennummer.SonstigeDaten';
    xdsTicketKundennummerSonstigeDaten.Size := 255;
    xdsTicketKundennummerB2C.SetParentComponent(xdsTicket);
    xdsTicketKundennummerB2C.Name := 'xdsTicketKundennummerB2C';
    xdsTicketKundennummerB2C.FieldName := 'Kundennummer.B2C';
    xdsTicketKundennummerTIN.SetParentComponent(xdsTicket);
    xdsTicketKundennummerTIN.Name := 'xdsTicketKundennummerTIN';
    xdsTicketKundennummerTIN.FieldName := 'Kundennummer.TIN';
    xdsTicketKundennummerTIN.Size := 25;
    xdsTicketKundennummerMindestbestellwert.SetParentComponent(xdsTicket);
    xdsTicketKundennummerMindestbestellwert.Name := 'xdsTicketKundennummerMindestbestellwert';
    xdsTicketKundennummerMindestbestellwert.FieldName := 'Kundennummer.Mindestbestellwert';
    xdsTicketKundennummerBruttoberechnung.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBruttoberechnung.Name := 'xdsTicketKundennummerBruttoberechnung';
    xdsTicketKundennummerBruttoberechnung.FieldName := 'Kundennummer.Bruttoberechnung';
    xdsTicketKundennummerDruckWHG.SetParentComponent(xdsTicket);
    xdsTicketKundennummerDruckWHG.Name := 'xdsTicketKundennummerDruckWHG';
    xdsTicketKundennummerDruckWHG.FieldName := 'Kundennummer.DruckWHG';
    xdsTicketKundennummerDruckWHG.Size := 3;
    xdsTicketKundennummerBerechtigungen.SetParentComponent(xdsTicket);
    xdsTicketKundennummerBerechtigungen.Name := 'xdsTicketKundennummerBerechtigungen';
    xdsTicketKundennummerBerechtigungen.FieldName := 'Kundennummer.Berechtigungen';
    xdsTicketKundennummerBerechtigungen.Size := 255;
    xdsTicketKundennummerRechnungCC.SetParentComponent(xdsTicket);
    xdsTicketKundennummerRechnungCC.Name := 'xdsTicketKundennummerRechnungCC';
    xdsTicketKundennummerRechnungCC.FieldName := 'Kundennummer.RechnungCC';
    xdsTicketKundennummerRechnungCC.Size := 50;
    xdsTicketProdukt.SetParentComponent(xdsTicket);
    xdsTicketProdukt.Name := 'xdsTicketProdukt';
    xdsTicketProdukt.FieldName := 'Produkt';
    xdsTicketProduktProdukt.SetParentComponent(xdsTicket);
    xdsTicketProduktProdukt.Name := 'xdsTicketProduktProdukt';
    xdsTicketProduktProdukt.FieldName := 'Produkt.Produkt';
    xdsTicketProduktProdukt.Size := 50;
    xdsTicketKategorie.SetParentComponent(xdsTicket);
    xdsTicketKategorie.Name := 'xdsTicketKategorie';
    xdsTicketKategorie.FieldName := 'Kategorie';
    xdsTicketKategorieKategorie.SetParentComponent(xdsTicket);
    xdsTicketKategorieKategorie.Name := 'xdsTicketKategorieKategorie';
    xdsTicketKategorieKategorie.FieldName := 'Kategorie.Kategorie';
    xdsTicketKategorieKategorie.Size := 25;
    xdsTicketPrioritaet.SetParentComponent(xdsTicket);
    xdsTicketPrioritaet.Name := 'xdsTicketPrioritaet';
    xdsTicketPrioritaet.FieldName := 'Prioritaet';
    xdsTicketPrioritaetPrioritaet.SetParentComponent(xdsTicket);
    xdsTicketPrioritaetPrioritaet.Name := 'xdsTicketPrioritaetPrioritaet';
    xdsTicketPrioritaetPrioritaet.FieldName := 'Prioritaet.Prioritaet';
    xdsTicketPrioritaetPrioText.SetParentComponent(xdsTicket);
    xdsTicketPrioritaetPrioText.Name := 'xdsTicketPrioritaetPrioText';
    xdsTicketPrioritaetPrioText.FieldName := 'Prioritaet.PrioText';
    xdsTicketPrioritaetPrioFarbe.SetParentComponent(xdsTicket);
    xdsTicketPrioritaetPrioFarbe.Name := 'xdsTicketPrioritaetPrioFarbe';
    xdsTicketPrioritaetPrioFarbe.FieldName := 'Prioritaet.PrioFarbe';
    xdsTicketStatus.SetParentComponent(xdsTicket);
    xdsTicketStatus.Name := 'xdsTicketStatus';
    xdsTicketStatus.FieldName := 'Status';
    xdsTicketID.SetParentComponent(xdsTicket);
    xdsTicketID.Name := 'xdsTicketID';
    xdsTicketID.FieldName := 'ID';
    xdsTicketID.Required := True;
    xdsTicketErstelltAm.SetParentComponent(xdsTicket);
    xdsTicketErstelltAm.Name := 'xdsTicketErstelltAm';
    xdsTicketErstelltAm.FieldName := 'ErstelltAm';
    xdsTicketBetreff.SetParentComponent(xdsTicket);
    xdsTicketBetreff.Name := 'xdsTicketBetreff';
    xdsTicketBetreff.FieldName := 'Betreff';
    xdsTicketBetreff.Size := 100;
    xdsTicketBeschreibung.SetParentComponent(xdsTicket);
    xdsTicketBeschreibung.Name := 'xdsTicketBeschreibung';
    xdsTicketBeschreibung.FieldName := 'Beschreibung';
    xdsTicketBeschreibung.Size := 255;
    xdsTicketAbrechnungsbetrag.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungsbetrag.Name := 'xdsTicketAbrechnungsbetrag';
    xdsTicketAbrechnungsbetrag.FieldName := 'Abrechnungsbetrag';
    xdsTicketAbrechnungRechnungsnummer.SetParentComponent(xdsTicket);
    xdsTicketAbrechnungRechnungsnummer.Name := 'xdsTicketAbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.FieldName := 'AbrechnungRechnungsnummer';
    xdsTicketAbrechnungRechnungsnummer.Size := 10;
    xdsTicketAberechnetAm.SetParentComponent(xdsTicket);
    xdsTicketAberechnetAm.Name := 'xdsTicketAberechnetAm';
    xdsTicketAberechnetAm.FieldName := 'AberechnetAm';
    xdsTicketErledigtAm.SetParentComponent(xdsTicket);
    xdsTicketErledigtAm.Name := 'xdsTicketErledigtAm';
    xdsTicketErledigtAm.FieldName := 'ErledigtAm';
    xdsTicketNachname.SetParentComponent(xdsTicket);
    xdsTicketNachname.Name := 'xdsTicketNachname';
    xdsTicketNachname.FieldName := 'Nachname';
    xdsTicketNachname.Size := 40;
    xdsTicketVorname.SetParentComponent(xdsTicket);
    xdsTicketVorname.Name := 'xdsTicketVorname';
    xdsTicketVorname.FieldName := 'Vorname';
    xdsTicketVorname.Size := 40;
    xdsTicketEmail.SetParentComponent(xdsTicket);
    xdsTicketEmail.Name := 'xdsTicketEmail';
    xdsTicketEmail.FieldName := 'Email';
    xdsTicketEmail.Size := 50;
    xdsTicketSystemInfo.SetParentComponent(xdsTicket);
    xdsTicketSystemInfo.Name := 'xdsTicketSystemInfo';
    xdsTicketSystemInfo.FieldName := 'SystemInfo';
    xdsTicketSystemInfo.Size := 255;
    xdsTicketLoesung.SetParentComponent(xdsTicket);
    xdsTicketLoesung.Name := 'xdsTicketLoesung';
    xdsTicketLoesung.FieldName := 'Loesung';
    xdsTicketLoesung.Size := 255;
    xdsTicketProtokoll.SetParentComponent(xdsTicket);
    xdsTicketProtokoll.Name := 'xdsTicketProtokoll';
    xdsTicketProtokoll.FieldName := 'Protokoll';
    xdsTicketProtokoll.Size := 255;
    xdsTicketZeitaufwandMinuten.SetParentComponent(xdsTicket);
    xdsTicketZeitaufwandMinuten.Name := 'xdsTicketZeitaufwandMinuten';
    xdsTicketZeitaufwandMinuten.FieldName := 'ZeitaufwandMinuten';
    xdsTicketAbzurechnendeMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbzurechnendeMinuten.Name := 'xdsTicketAbzurechnendeMinuten';
    xdsTicketAbzurechnendeMinuten.FieldName := 'AbzurechnendeMinuten';
    xdsTicketAbgerechneteMinuten.SetParentComponent(xdsTicket);
    xdsTicketAbgerechneteMinuten.Name := 'xdsTicketAbgerechneteMinuten';
    xdsTicketAbgerechneteMinuten.FieldName := 'AbgerechneteMinuten';
    xdsTicketBenachrichtigungNEU.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungNEU.Name := 'xdsTicketBenachrichtigungNEU';
    xdsTicketBenachrichtigungNEU.FieldName := 'BenachrichtigungNEU';
    xdsTicketBenachrichtigungLoesung.SetParentComponent(xdsTicket);
    xdsTicketBenachrichtigungLoesung.Name := 'xdsTicketBenachrichtigungLoesung';
    xdsTicketBenachrichtigungLoesung.FieldName := 'BenachrichtigungLoesung';
    xdsTicketInterneBemerkung.SetParentComponent(xdsTicket);
    xdsTicketInterneBemerkung.Name := 'xdsTicketInterneBemerkung';
    xdsTicketInterneBemerkung.FieldName := 'InterneBemerkung';
    xdsTicketInterneBemerkung.Size := 255;
    xdsTicketLoesungInfoSenden.SetParentComponent(xdsTicket);
    xdsTicketLoesungInfoSenden.Name := 'xdsTicketLoesungInfoSenden';
    xdsTicketLoesungInfoSenden.FieldName := 'LoesungInfoSenden';
    xdsTicketKontaktperson.SetParentComponent(xdsTicket);
    xdsTicketKontaktperson.Name := 'xdsTicketKontaktperson';
    xdsTicketKontaktperson.FieldName := 'Kontaktperson';
    xdsTicketKontaktperson.Size := 100;
    xdsTicketErreichbarkeitTelefon.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitTelefon.Name := 'xdsTicketErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.FieldName := 'ErreichbarkeitTelefon';
    xdsTicketErreichbarkeitTelefon.Size := 100;
    xdsTicketErreichbarkeitWann.SetParentComponent(xdsTicket);
    xdsTicketErreichbarkeitWann.Name := 'xdsTicketErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.FieldName := 'ErreichbarkeitWann';
    xdsTicketErreichbarkeitWann.Size := 100;
    xdsTicketStatusStatus.SetParentComponent(xdsTicket);
    xdsTicketStatusStatus.Name := 'xdsTicketStatusStatus';
    xdsTicketStatusStatus.FieldName := 'Status.Status';
    xdsTicketStatusStatus.Size := 25;
    xdsTicketKontaktpersonEmail.SetParentComponent(xdsTicket);
    xdsTicketKontaktpersonEmail.Name := 'xdsTicketKontaktpersonEmail';
    xdsTicketKontaktpersonEmail.FieldName := 'KontaktpersonEmail';
    xdsTicketKontaktpersonEmail.Size := 100;
    xdsTStatus.SetParentComponent(Self);
    xdsTStatus.Name := 'xdsTStatus';
    xdsTStatus.AfterOpen := xdsTStatusAfterOpen;
    xdsTStatus.EntitySetName := 'ITS_TicketStatus';
    xdsTStatus.Connection := DM2.XDataWebConnection1;
    xdsTStatus.Left := 176;
    xdsTStatus.Top := 24;
    xdsTStatusStatus.SetParentComponent(xdsTStatus);
    xdsTStatusStatus.Name := 'xdsTStatusStatus';
    xdsTStatusStatus.FieldName := 'Status';
    xdsTStatusStatus.Required := True;
    xdsTStatusStatus.Size := 25;
    sourceTicket.SetParentComponent(Self);
    sourceTicket.Name := 'sourceTicket';
    sourceTicket.DataSet := xdsTicket;
    SetEvent(sourceTicket, Self, 'OnStateChange', 'sourceTicketStateChange');
    sourceTicket.Left := 160;
    sourceTicket.Top := 228;
    sourceTStatus.SetParentComponent(Self);
    sourceTStatus.Name := 'sourceTStatus';
    sourceTStatus.DataSet := xdsTStatus;
    sourceTStatus.Left := 176;
    sourceTStatus.Top := 76;
    xdsTicketKonversation.SetParentComponent(Self);
    xdsTicketKonversation.Name := 'xdsTicketKonversation';
    xdsTicketKonversation.AfterApplyUpdates := xdsTicketKonversationAfterApplyUpdates;
    xdsTicketKonversation.AfterOpen := xdsTicketKonversationAfterOpen;
    xdsTicketKonversation.AfterPost := xdsTicketKonversationAfterPost;
    xdsTicketKonversation.EntitySetName := 'ITS_TicketKonversation';
    xdsTicketKonversation.Connection := DM2.XDataWebConnection1;
    xdsTicketKonversation.Left := 176;
    xdsTicketKonversation.Top := 136;
    xdsTicketKonversationTicketID.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationTicketID.Name := 'xdsTicketKonversationTicketID';
    xdsTicketKonversationTicketID.FieldName := 'TicketID';
    xdsTicketKonversationTicketID.Required := True;
    xdsTicketKonversationID.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationID.Name := 'xdsTicketKonversationID';
    xdsTicketKonversationID.FieldName := 'ID';
    xdsTicketKonversationDatumUhrzeit.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationDatumUhrzeit.Name := 'xdsTicketKonversationDatumUhrzeit';
    xdsTicketKonversationDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsTicketKonversationDatumUhrzeit.Required := True;
    xdsTicketKonversationAntwortText.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationAntwortText.Name := 'xdsTicketKonversationAntwortText';
    xdsTicketKonversationAntwortText.FieldName := 'AntwortText';
    xdsTicketKonversationAntwortText.Size := 255;
    xdsTicketKonversationNachrichtSenden.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationNachrichtSenden.Name := 'xdsTicketKonversationNachrichtSenden';
    xdsTicketKonversationNachrichtSenden.FieldName := 'NachrichtSenden';
    xdsTicketKonversationNachrichtGesendet.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationNachrichtGesendet.Name := 'xdsTicketKonversationNachrichtGesendet';
    xdsTicketKonversationNachrichtGesendet.FieldName := 'NachrichtGesendet';
    xdsTicketKonversationVerfasser.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationVerfasser.Name := 'xdsTicketKonversationVerfasser';
    xdsTicketKonversationVerfasser.FieldName := 'Verfasser';
    xdsTicketKonversationVerfasser.Size := 50;
    xdsTicketKonversationQuellProgramm.SetParentComponent(xdsTicketKonversation);
    xdsTicketKonversationQuellProgramm.Name := 'xdsTicketKonversationQuellProgramm';
    xdsTicketKonversationQuellProgramm.FieldName := 'QuellProgramm';
    xdsTicketKonversationQuellProgramm.Size := 50;
    sourceTicketKonversation.SetParentComponent(Self);
    sourceTicketKonversation.Name := 'sourceTicketKonversation';
    sourceTicketKonversation.DataSet := xdsTicketKonversation;
    sourceTicketKonversation.Left := 176;
    sourceTicketKonversation.Top := 188;
    xdsTicketDateien.SetParentComponent(Self);
    xdsTicketDateien.Name := 'xdsTicketDateien';
    xdsTicketDateien.AfterOpen := xdsTicketDateienAfterOpen;
    xdsTicketDateien.EntitySetName := 'ITS_TicketDateien';
    xdsTicketDateien.Connection := DM2.XDataWebConnection1;
    xdsTicketDateien.Left := 176;
    xdsTicketDateien.Top := 432;
    xdsTicketDateienID.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienID.Name := 'xdsTicketDateienID';
    xdsTicketDateienID.FieldName := 'ID';
    xdsTicketDateienID.Required := True;
    xdsTicketDateienDatumUhrzeit.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDatumUhrzeit.Name := 'xdsTicketDateienDatumUhrzeit';
    xdsTicketDateienDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsTicketDateienDatumUhrzeit.Required := True;
    xdsTicketDateienDateiName.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiName.Name := 'xdsTicketDateienDateiName';
    xdsTicketDateienDateiName.FieldName := 'DateiName';
    xdsTicketDateienDateiName.Size := 255;
    xdsTicketDateienDateiGroesse.SetParentComponent(xdsTicketDateien);
    xdsTicketDateienDateiGroesse.Name := 'xdsTicketDateienDateiGroesse';
    xdsTicketDateienDateiGroesse.FieldName := 'DateiGroesse';
    xdskontosaldo.SetParentComponent(Self);
    xdskontosaldo.Name := 'xdskontosaldo';
    xdskontosaldo.AfterOpen := xdskontosaldoAfterOpen;
    xdskontosaldo.EntitySetName := 'ITS_Kontosalden';
    xdskontosaldo.Connection := DM2.XDataWebConnection1;
    xdskontosaldo.Left := 128;
    xdskontosaldo.Top := 544;
    xdskontosaldoKundennummer.SetParentComponent(xdskontosaldo);
    xdskontosaldoKundennummer.Name := 'xdskontosaldoKundennummer';
    xdskontosaldoKundennummer.FieldName := 'Kundennummer';
    xdskontosaldoKundennummer.Required := True;
    xdskontosaldoKundennummer.Size := 13;
    xdskontosaldoZeitaufwand.SetParentComponent(xdskontosaldo);
    xdskontosaldoZeitaufwand.Name := 'xdskontosaldoZeitaufwand';
    xdskontosaldoZeitaufwand.FieldName := 'Zeitaufwand';
    xdskontosaldoAbzurechnen.SetParentComponent(xdskontosaldo);
    xdskontosaldoAbzurechnen.Name := 'xdskontosaldoAbzurechnen';
    xdskontosaldoAbzurechnen.FieldName := 'Abzurechnen';
    xdskontosaldoGutschrift.SetParentComponent(xdskontosaldo);
    xdskontosaldoGutschrift.Name := 'xdskontosaldoGutschrift';
    xdskontosaldoGutschrift.FieldName := 'Gutschrift';
    xdskontosaldoAbzug.SetParentComponent(xdskontosaldo);
    xdskontosaldoAbzug.Name := 'xdskontosaldoAbzug';
    xdskontosaldoAbzug.FieldName := 'Abzug';
    xdskontosaldoSaldo.SetParentComponent(xdskontosaldo);
    xdskontosaldoSaldo.Name := 'xdskontosaldoSaldo';
    xdskontosaldoSaldo.FieldName := 'Saldo';
    xdskontosaldoBetrag.SetParentComponent(xdskontosaldo);
    xdskontosaldoBetrag.Name := 'xdskontosaldoBetrag';
    xdskontosaldoBetrag.FieldName := 'Betrag';
    xdskontosaldoMinutenpreis.SetParentComponent(xdskontosaldo);
    xdskontosaldoMinutenpreis.Name := 'xdskontosaldoMinutenpreis';
    xdskontosaldoMinutenpreis.FieldName := 'Minutenpreis';
    xdskontosaldoSRestguthaben.SetParentComponent(xdskontosaldo);
    xdskontosaldoSRestguthaben.Name := 'xdskontosaldoSRestguthaben';
    xdskontosaldoSRestguthaben.FieldName := 'SRestguthaben';
    xdsSingleFile.SetParentComponent(Self);
    xdsSingleFile.Name := 'xdsSingleFile';
    xdsSingleFile.AfterOpen := xdsSingleFileAfterOpen;
    xdsSingleFile.EntitySetName := 'ITS_TicketDateien';
    xdsSingleFile.Connection := DM2.XDataWebConnection1;
    xdsSingleFile.QueryTop := 1;
    xdsSingleFile.Left := 496;
    xdsSingleFile.Top := 272;
    xdsSingleFileTicketID.SetParentComponent(xdsSingleFile);
    xdsSingleFileTicketID.Name := 'xdsSingleFileTicketID';
    xdsSingleFileTicketID.FieldName := 'TicketID';
    xdsSingleFileTicketID.Required := True;
    xdsSingleFileID.SetParentComponent(xdsSingleFile);
    xdsSingleFileID.Name := 'xdsSingleFileID';
    xdsSingleFileID.FieldName := 'ID';
    xdsSingleFileID.Required := True;
    xdsSingleFileDatumUhrzeit.SetParentComponent(xdsSingleFile);
    xdsSingleFileDatumUhrzeit.Name := 'xdsSingleFileDatumUhrzeit';
    xdsSingleFileDatumUhrzeit.FieldName := 'DatumUhrzeit';
    xdsSingleFileDatumUhrzeit.Required := True;
    xdsSingleFileFuerLoesung.SetParentComponent(xdsSingleFile);
    xdsSingleFileFuerLoesung.Name := 'xdsSingleFileFuerLoesung';
    xdsSingleFileFuerLoesung.FieldName := 'FuerLoesung';
    xdsSingleFileDateiMime.SetParentComponent(xdsSingleFile);
    xdsSingleFileDateiMime.Name := 'xdsSingleFileDateiMime';
    xdsSingleFileDateiMime.FieldName := 'DateiMime';
    xdsSingleFileDateiMime.Size := 50;
    xdsSingleFileDateiName.SetParentComponent(xdsSingleFile);
    xdsSingleFileDateiName.Name := 'xdsSingleFileDateiName';
    xdsSingleFileDateiName.FieldName := 'DateiName';
    xdsSingleFileDateiName.Size := 255;
    xdsSingleFileDateiGroesse.SetParentComponent(xdsSingleFile);
    xdsSingleFileDateiGroesse.Name := 'xdsSingleFileDateiGroesse';
    xdsSingleFileDateiGroesse.FieldName := 'DateiGroesse';
    xdsSingleFileDateiInhaltText.SetParentComponent(xdsSingleFile);
    xdsSingleFileDateiInhaltText.Name := 'xdsSingleFileDateiInhaltText';
    xdsSingleFileDateiInhaltText.FieldName := 'DateiInhaltText';
    xdsSingleFileDateiInhaltText.Size := 255;
  finally
    lblinfo.AfterLoadDFMValues;
    lblKonversation.AfterLoadDFMValues;
    lblDateien.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnSpeichern.AfterLoadDFMValues;
    webDBCStatus.AfterLoadDFMValues;
    btnAntwortNeu.AfterLoadDFMValues;
    edtNotiz.AfterLoadDFMValues;
    btnAntwortSpeichern.AfterLoadDFMValues;
    checkBenachrichtigung.AfterLoadDFMValues;
    Container4.AfterLoadDFMValues;
    Container5.AfterLoadDFMValues;
    xdsTicket.AfterLoadDFMValues;
    xdsTicketKundennummer.AfterLoadDFMValues;
    xdsTicketKundennummerZahlungsbedingung.AfterLoadDFMValues;
    xdsTicketKundennummerKundennummer.AfterLoadDFMValues;
    xdsTicketKundennummerGruppeKunden.AfterLoadDFMValues;
    xdsTicketKundennummerGruppeLieferanten.AfterLoadDFMValues;
    xdsTicketKundennummerGruppeSonstige.AfterLoadDFMValues;
    xdsTicketKundennummerGruppeNichtkunden.AfterLoadDFMValues;
    xdsTicketKundennummerKontaktgruppe.AfterLoadDFMValues;
    xdsTicketKundennummerNachname.AfterLoadDFMValues;
    xdsTicketKundennummerVorname.AfterLoadDFMValues;
    xdsTicketKundennummerAdresszeile2.AfterLoadDFMValues;
    xdsTicketKundennummerAdresszeile3.AfterLoadDFMValues;
    xdsTicketKundennummerStrasse.AfterLoadDFMValues;
    xdsTicketKundennummerPostleitzahl.AfterLoadDFMValues;
    xdsTicketKundennummerOrt.AfterLoadDFMValues;
    xdsTicketKundennummerLaenderkuerzel.AfterLoadDFMValues;
    xdsTicketKundennummerLand.AfterLoadDFMValues;
    xdsTicketKundennummerLaenderkennzeichen.AfterLoadDFMValues;
    xdsTicketKundennummerAdressanrede.AfterLoadDFMValues;
    xdsTicketKundennummerBriefanrede1.AfterLoadDFMValues;
    xdsTicketKundennummerBriefanrede2.AfterLoadDFMValues;
    xdsTicketKundennummerAdresseBild.AfterLoadDFMValues;
    xdsTicketKundennummerLieferanschrift.AfterLoadDFMValues;
    xdsTicketKundennummerGeburtsdatum.AfterLoadDFMValues;
    xdsTicketKundennummerTelefonNummer.AfterLoadDFMValues;
    xdsTicketKundennummerTelefaxNummer.AfterLoadDFMValues;
    xdsTicketKundennummerMobilTelefon.AfterLoadDFMValues;
    xdsTicketKundennummerEMail.AfterLoadDFMValues;
    xdsTicketKundennummerInternet.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzsteuerID.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzsteuerausweis.AfterLoadDFMValues;
    xdsTicketKundennummerBemerkungen.AfterLoadDFMValues;
    xdsTicketKundennummerBranche.AfterLoadDFMValues;
    xdsTicketKundennummerSelektiert1.AfterLoadDFMValues;
    xdsTicketKundennummerSelektiert2.AfterLoadDFMValues;
    xdsTicketKundennummerSelektiert3.AfterLoadDFMValues;
    xdsTicketKundennummerTransportbedingung.AfterLoadDFMValues;
    xdsTicketKundennummerKilometer.AfterLoadDFMValues;
    xdsTicketKundennummerRabattsatz.AfterLoadDFMValues;
    xdsTicketKundennummerStundensatz.AfterLoadDFMValues;
    xdsTicketKundennummerKontonummer.AfterLoadDFMValues;
    xdsTicketKundennummerBank.AfterLoadDFMValues;
    xdsTicketKundennummerBankleitzahl.AfterLoadDFMValues;
    xdsTicketKundennummerKontoinhaber.AfterLoadDFMValues;
    xdsTicketKundennummerBetreuer.AfterLoadDFMValues;
    xdsTicketKundennummerQuelle.AfterLoadDFMValues;
    xdsTicketKundennummerSuchmerkmal.AfterLoadDFMValues;
    xdsTicketKundennummerWarenkreditlimit.AfterLoadDFMValues;
    xdsTicketKundennummerWarenkreditgesperrt.AfterLoadDFMValues;
    xdsTicketKundennummerKundennummerFremd.AfterLoadDFMValues;
    xdsTicketKundennummerKeinNewsletter.AfterLoadDFMValues;
    xdsTicketKundennummerDebitorennummer.AfterLoadDFMValues;
    xdsTicketKundennummerKreditorennummer.AfterLoadDFMValues;
    xdsTicketKundennummerRabattstufe.AfterLoadDFMValues;
    xdsTicketKundennummerTelefonAlternativ.AfterLoadDFMValues;
    xdsTicketKundennummerKostentraeger.AfterLoadDFMValues;
    xdsTicketKundennummerIBAN.AfterLoadDFMValues;
    xdsTicketKundennummerBIC.AfterLoadDFMValues;
    xdsTicketKundennummerEmailkonto.AfterLoadDFMValues;
    xdsTicketKundennummerBenutzername.AfterLoadDFMValues;
    xdsTicketKundennummerPasswort.AfterLoadDFMValues;
    xdsTicketKundennummerExportOutlook.AfterLoadDFMValues;
    xdsTicketKundennummerNichtInListeAnzeigen.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkarteArt.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkarteInhaber.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkarteNummer.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkarteGueltigMonat.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkarteGueltigJahr.AfterLoadDFMValues;
    xdsTicketKundennummerKreditkartePruefziffer.AfterLoadDFMValues;
    xdsTicketKundennummerDatumNeu.AfterLoadDFMValues;
    xdsTicketKundennummerDatumgeaendert.AfterLoadDFMValues;
    xdsTicketKundennummerTitel.AfterLoadDFMValues;
    xdsTicketKundennummerStundensatzMontage.AfterLoadDFMValues;
    xdsTicketKundennummerStdMontageU25.AfterLoadDFMValues;
    xdsTicketKundennummerStdMontageU50.AfterLoadDFMValues;
    xdsTicketKundennummerStdMontageU70.AfterLoadDFMValues;
    xdsTicketKundennummerStdMontageU100.AfterLoadDFMValues;
    xdsTicketKundennummerStdMontageU150.AfterLoadDFMValues;
    xdsTicketKundennummerStundensatzWerkstatt.AfterLoadDFMValues;
    xdsTicketKundennummerStdWerkstattU25.AfterLoadDFMValues;
    xdsTicketKundennummerStdWerkstattU50.AfterLoadDFMValues;
    xdsTicketKundennummerStdWerkstattU70.AfterLoadDFMValues;
    xdsTicketKundennummerStdWerkstattU100.AfterLoadDFMValues;
    xdsTicketKundennummerStdWerkstattU150.AfterLoadDFMValues;
    xdsTicketKundennummerArchivReferenz.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST1.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST2.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST3.AfterLoadDFMValues;
    xdsTicketKundennummerGebKal.AfterLoadDFMValues;
    xdsTicketKundennummerEmailversand.AfterLoadDFMValues;
    xdsTicketKundennummerMahnspesen.AfterLoadDFMValues;
    xdsTicketKundennummerRechnungSchluss.AfterLoadDFMValues;
    xdsTicketKundennummerBenutzerNeu.AfterLoadDFMValues;
    xdsTicketKundennummerBenutzerGeaendert.AfterLoadDFMValues;
    xdsTicketKundennummerBelegsprache.AfterLoadDFMValues;
    xdsTicketKundennummerkmSatz.AfterLoadDFMValues;
    xdsTicketKundennummerKundenklassetext.AfterLoadDFMValues;
    xdsTicketKundennummerKundenklasseFarbe.AfterLoadDFMValues;
    xdsTicketKundennummerAbweichenderRechnungsEmpfaenger.AfterLoadDFMValues;
    xdsTicketKundennummerProtokoll.AfterLoadDFMValues;
    xdsTicketKundennummerILNTyp1.AfterLoadDFMValues;
    xdsTicketKundennummerILNTyp2.AfterLoadDFMValues;
    xdsTicketKundennummerKontaktGUID.AfterLoadDFMValues;
    xdsTicketKundennummerPLZGUID.AfterLoadDFMValues;
    xdsTicketKundennummerPreislistenVariantePakete.AfterLoadDFMValues;
    xdsTicketKundennummerSchluesselRechnungslauf.AfterLoadDFMValues;
    xdsTicketKundennummerRechnungEmail.AfterLoadDFMValues;
    xdsTicketKundennummerZahlungsbedingungEK.AfterLoadDFMValues;
    xdsTicketKundennummerTransportbedingungEK.AfterLoadDFMValues;
    xdsTicketKundennummerRabattsatzEK.AfterLoadDFMValues;
    xdsTicketKundennummerVertreterMatchcode.AfterLoadDFMValues;
    xdsTicketKundennummerVertreterProvisionssatz.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzVKJahr.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzVKVorjahr.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzEKJahr.AfterLoadDFMValues;
    xdsTicketKundennummerUmsatzEKVorjahr.AfterLoadDFMValues;
    xdsTicketKundennummerSteuernummer.AfterLoadDFMValues;
    xdsTicketKundennummerLoginPW.AfterLoadDFMValues;
    xdsTicketKundennummerREperFax.AfterLoadDFMValues;
    xdsTicketKundennummerErreichbarkeit.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST4.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST5.AfterLoadDFMValues;
    xdsTicketKundennummerErloesKontoUST6.AfterLoadDFMValues;
    xdsTicketKundennummerBesteuerungKey.AfterLoadDFMValues;
    xdsTicketKundennummerAuftraegeJahr.AfterLoadDFMValues;
    xdsTicketKundennummerAuftraegeVorjahr.AfterLoadDFMValues;
    xdsTicketKundennummerLieferadresseID.AfterLoadDFMValues;
    xdsTicketKundennummerUSTIDgeprueft.AfterLoadDFMValues;
    xdsTicketKundennummerKontaktverbund.AfterLoadDFMValues;
    xdsTicketKundennummerHinweis.AfterLoadDFMValues;
    xdsTicketKundennummerLatitude.AfterLoadDFMValues;
    xdsTicketKundennummerLongitude.AfterLoadDFMValues;
    xdsTicketKundennummerkmLuftlinie.AfterLoadDFMValues;
    xdsTicketKundennummerGoogleID.AfterLoadDFMValues;
    xdsTicketKundennummerGoogleUpdatedUTC.AfterLoadDFMValues;
    xdsTicketKundennummerBundesland.AfterLoadDFMValues;
    xdsTicketKundennummerRegion.AfterLoadDFMValues;
    xdsTicketKundennummerMandatsreferenz.AfterLoadDFMValues;
    xdsTicketKundennummerMandatsreferenzVom.AfterLoadDFMValues;
    xdsTicketKundennummerLastschriftArt.AfterLoadDFMValues;
    xdsTicketKundennummerMahnsperre.AfterLoadDFMValues;
    xdsTicketKundennummerSuchbegriff.AfterLoadDFMValues;
    xdsTicketKundennummerLieferanschriftDaten.AfterLoadDFMValues;
    xdsTicketKundennummerExportKasse.AfterLoadDFMValues;
    xdsTicketKundennummerLoeschvormerkungDatum.AfterLoadDFMValues;
    xdsTicketKundennummerLoeschvormerkungGrund.AfterLoadDFMValues;
    xdsTicketKundennummerPseudonymisiert.AfterLoadDFMValues;
    xdsTicketKundennummerLoginAktiv.AfterLoadDFMValues;
    xdsTicketKundennummerSonstigeDaten.AfterLoadDFMValues;
    xdsTicketKundennummerB2C.AfterLoadDFMValues;
    xdsTicketKundennummerTIN.AfterLoadDFMValues;
    xdsTicketKundennummerMindestbestellwert.AfterLoadDFMValues;
    xdsTicketKundennummerBruttoberechnung.AfterLoadDFMValues;
    xdsTicketKundennummerDruckWHG.AfterLoadDFMValues;
    xdsTicketKundennummerBerechtigungen.AfterLoadDFMValues;
    xdsTicketKundennummerRechnungCC.AfterLoadDFMValues;
    xdsTicketProdukt.AfterLoadDFMValues;
    xdsTicketProduktProdukt.AfterLoadDFMValues;
    xdsTicketKategorie.AfterLoadDFMValues;
    xdsTicketKategorieKategorie.AfterLoadDFMValues;
    xdsTicketPrioritaet.AfterLoadDFMValues;
    xdsTicketPrioritaetPrioritaet.AfterLoadDFMValues;
    xdsTicketPrioritaetPrioText.AfterLoadDFMValues;
    xdsTicketPrioritaetPrioFarbe.AfterLoadDFMValues;
    xdsTicketStatus.AfterLoadDFMValues;
    xdsTicketID.AfterLoadDFMValues;
    xdsTicketErstelltAm.AfterLoadDFMValues;
    xdsTicketBetreff.AfterLoadDFMValues;
    xdsTicketBeschreibung.AfterLoadDFMValues;
    xdsTicketAbrechnungsbetrag.AfterLoadDFMValues;
    xdsTicketAbrechnungRechnungsnummer.AfterLoadDFMValues;
    xdsTicketAberechnetAm.AfterLoadDFMValues;
    xdsTicketErledigtAm.AfterLoadDFMValues;
    xdsTicketNachname.AfterLoadDFMValues;
    xdsTicketVorname.AfterLoadDFMValues;
    xdsTicketEmail.AfterLoadDFMValues;
    xdsTicketSystemInfo.AfterLoadDFMValues;
    xdsTicketLoesung.AfterLoadDFMValues;
    xdsTicketProtokoll.AfterLoadDFMValues;
    xdsTicketZeitaufwandMinuten.AfterLoadDFMValues;
    xdsTicketAbzurechnendeMinuten.AfterLoadDFMValues;
    xdsTicketAbgerechneteMinuten.AfterLoadDFMValues;
    xdsTicketBenachrichtigungNEU.AfterLoadDFMValues;
    xdsTicketBenachrichtigungLoesung.AfterLoadDFMValues;
    xdsTicketInterneBemerkung.AfterLoadDFMValues;
    xdsTicketLoesungInfoSenden.AfterLoadDFMValues;
    xdsTicketKontaktperson.AfterLoadDFMValues;
    xdsTicketErreichbarkeitTelefon.AfterLoadDFMValues;
    xdsTicketErreichbarkeitWann.AfterLoadDFMValues;
    xdsTicketStatusStatus.AfterLoadDFMValues;
    xdsTicketKontaktpersonEmail.AfterLoadDFMValues;
    xdsTStatus.AfterLoadDFMValues;
    xdsTStatusStatus.AfterLoadDFMValues;
    sourceTicket.AfterLoadDFMValues;
    sourceTStatus.AfterLoadDFMValues;
    xdsTicketKonversation.AfterLoadDFMValues;
    xdsTicketKonversationTicketID.AfterLoadDFMValues;
    xdsTicketKonversationID.AfterLoadDFMValues;
    xdsTicketKonversationDatumUhrzeit.AfterLoadDFMValues;
    xdsTicketKonversationAntwortText.AfterLoadDFMValues;
    xdsTicketKonversationNachrichtSenden.AfterLoadDFMValues;
    xdsTicketKonversationNachrichtGesendet.AfterLoadDFMValues;
    xdsTicketKonversationVerfasser.AfterLoadDFMValues;
    xdsTicketKonversationQuellProgramm.AfterLoadDFMValues;
    sourceTicketKonversation.AfterLoadDFMValues;
    xdsTicketDateien.AfterLoadDFMValues;
    xdsTicketDateienID.AfterLoadDFMValues;
    xdsTicketDateienDatumUhrzeit.AfterLoadDFMValues;
    xdsTicketDateienDateiName.AfterLoadDFMValues;
    xdsTicketDateienDateiGroesse.AfterLoadDFMValues;
    xdskontosaldo.AfterLoadDFMValues;
    xdskontosaldoKundennummer.AfterLoadDFMValues;
    xdskontosaldoZeitaufwand.AfterLoadDFMValues;
    xdskontosaldoAbzurechnen.AfterLoadDFMValues;
    xdskontosaldoGutschrift.AfterLoadDFMValues;
    xdskontosaldoAbzug.AfterLoadDFMValues;
    xdskontosaldoSaldo.AfterLoadDFMValues;
    xdskontosaldoBetrag.AfterLoadDFMValues;
    xdskontosaldoMinutenpreis.AfterLoadDFMValues;
    xdskontosaldoSRestguthaben.AfterLoadDFMValues;
    xdsSingleFile.AfterLoadDFMValues;
    xdsSingleFileTicketID.AfterLoadDFMValues;
    xdsSingleFileID.AfterLoadDFMValues;
    xdsSingleFileDatumUhrzeit.AfterLoadDFMValues;
    xdsSingleFileFuerLoesung.AfterLoadDFMValues;
    xdsSingleFileDateiMime.AfterLoadDFMValues;
    xdsSingleFileDateiName.AfterLoadDFMValues;
    xdsSingleFileDateiGroesse.AfterLoadDFMValues;
    xdsSingleFileDateiInhaltText.AfterLoadDFMValues;
  end;
end;

end.